export const ShakespeareGed = 
`
0 HEAD
1 SOUR webtreeprint.com
2 VERS 1.0
2 NAME webtreeprint
1 FILE shakespeare.ged
1 GEDC
2 VERS 5.5.1
2 FORM LINEAGE-LINKED
1 CHAR UTF-8
1 SUBM @SUB1@
0 @SUB1@ SUBM
1 NAME webTreePrint
0 @I0001@ INDI
1 NAME William /Shakespeare/
2 GIVN William
2 SURN Shakespeare
1 SEX M
1 BIRT
2 DATE BEF 23 APR 1564
2 PLAC Stratford-upon-Avon
1 CHR
2 DATE 26 APR 1564
2 PLAC Stratford-upon-Avon
1 DEAT
2 DATE 23 APR 1616
2 PLAC Stratford-upon-Avon
1 FAMC @F001@
1 FAMS @F002@
0 @I0002@ INDI
1 NAME Mary /Arden/
2 GIVN Mary
2 SURN Arden
1 SEX F
1 BIRT
2 DATE ABT 1537
1 DEAT
2 DATE SEP 1608
1 FAMC @F005@
1 FAMS @F001@
0 @I0003@ INDI
1 NAME John /Shakespeare/
2 GIVN John
2 SURN Shakespeare
1 SEX M
1 BIRT
2 DATE ABT 1531
1 DEAT
2 DATE 07 SEP 1601
1 BURI
2 DATE 08 SEP 1601
1 FAMC @F003@
1 FAMS @F001@
0 @I0004@ INDI
1 NAME Anne /Hathaway/
2 GIVN Anne
2 SURN Hathaway
1 SEX F
1 BIRT
2 DATE APR 1556
2 PLAC Shottery, Warwickshire
1 DEAT
2 DATE 06 AUG 1623
2 PLAC Stratford-upon-Avon
1 FAMC @F010@
1 FAMS @F002@
0 @I0005@ INDI
1 NAME Susanna /Shakespeare/
2 GIVN Susanna
2 SURN Shakespeare
1 SEX F
1 BIRT
2 DATE MAY 1583
2 PLAC Stratford-upon-Avon
1 CHR
2 DATE 26 MAY 1583
2 PLAC Stratford-upon-Avon
1 DEAT
2 DATE 11 JUL 1649
2 PLAC Stratford-upon-Avon
1 FAMC @F002@
1 FAMS @F006@
0 @I0006@ INDI
1 NAME Hamnet /Shakespeare/
2 GIVN Hamnet
2 SURN Shakespeare
1 SEX M
1 BIRT
2 DATE JAN 1585
2 PLAC Stratford-upon-Avon
1 CHR
2 DATE 02 FEB 1585
2 PLAC Stratford-upon-Avon
1 DEAT
2 DATE AUG 1596
2 PLAC Stratford-upon-Avon
1 BURI
2 DATE 11 AUG 1596
2 PLAC Stratford-upon-Avon
1 FAMC @F002@
0 @I0007@ INDI
1 NAME Judith /Shakespeare/
2 GIVN Judith
2 SURN Shakespeare
1 SEX F
1 BIRT
2 DATE JAN 1585
2 PLAC Stratford-upon-Avon
1 CHR
2 DATE 02 FEB 1585
2 PLAC Stratford-upon-Avon
1 DEAT
2 DATE FEB 1662
2 PLAC Stratford-upon-Avon
1 BURI
2 DATE 09 FEB 1662
2 PLAC Stratford-upon-Avon
1 FAMC @F002@
1 FAMS @F009@
0 @I0008@ INDI
1 NAME Joan /Shakespeare/
2 GIVN Joan
2 SURN Shakespeare
1 SEX F
1 BIRT
2 DATE SEP 1558
1 CHR
2 DATE 15 SEP 1558
1 DEAT
2 DATE AFT SEP 1558
1 FAMC @F001@
0 @I0009@ INDI
1 NAME Margaret /Shakespeare/
2 GIVN Margaret
2 SURN Shakespeare
1 SEX F
1 BIRT
2 DATE NOV 1562
1 CHR
2 DATE 02 DEC 1562
1 DEAT
2 DATE APR 1563
1 BURI
2 DATE 30 APR 1563
1 FAMC @F001@
0 @I0010@ INDI
1 NAME Gilbert /Shakespeare/
2 GIVN Gilbert
2 SURN Shakespeare
1 SEX M
1 BIRT
2 DATE OCT 1566
1 DEAT
2 DATE JAN 1612
1 FAMC @F001@
0 @I0011@ INDI
1 NAME Joan /Shakespeare/
2 GIVN Joan
2 SURN Shakespeare
1 SEX F
1 BIRT
2 DATE APR 1569
1 DEAT
2 DATE NOV 1646
1 FAMC @F001@
0 @I0012@ INDI
1 NAME Anne /Shakespeare/
2 GIVN Anne
2 SURN Shakespeare
1 SEX F
1 BIRT
2 DATE SEP 1571
1 DEAT
2 DATE APR 1579
1 FAMC @F001@
0 @I0013@ INDI
1 NAME Richard /Shakespeare/
2 GIVN Richard
2 SURN Shakespeare
1 SEX M
1 BIRT
2 DATE MAR 1574
1 DEAT
2 DATE FEB 1613
1 FAMC @F001@
0 @I0014@ INDI
1 NAME Edmund /Shakespeare/
2 GIVN Edmund
2 SURN Shakespeare
1 SEX M
1 BIRT
2 DATE APR 1580
1 DEAT
2 DATE DEC 1607
1 FAMC @F001@
0 @I0015@ INDI
1 NAME Richard /Shakespeare/
2 GIVN Richard
2 SURN Shakespeare
1 SEX M
1 BIRT
2 DATE ABT 1490
1 DEAT
2 DATE BEF 10 FEB 1561
1 FAMS @F003@
0 @I0016@ INDI
1 NAME Henry /Shakespeare/
2 GIVN Henry
2 SURN Shakespeare
1 SEX M
1 DEAT
2 DATE 1596
1 FAMC @F003@
1 FAMS @F004@
0 @I0017@ INDI
1 NAME Margaret //
2 GIVN Margaret
1 SEX F
1 DEAT
2 DATE 1597
1 FAMS @F004@
0 @I0018@ INDI
1 NAME Agnes /Webbe/
2 GIVN Agnes
2 SURN Webbe
1 SEX F
1 FAMS @F005@
0 @I0019@ INDI
1 NAME Robert /Arden/
2 GIVN Robert
2 SURN Arden
1 SEX M
1 DEAT
2 DATE DEC 1556
1 FAMS @F005@
0 @I0020@ INDI
1 NAME John /Hall/
2 GIVN John
2 SURN Hall
1 TITL Dr.
1 SEX M
1 BIRT
2 DATE 1575
1 DEAT
2 DATE NOV 1635
1 FAMS @F006@
0 @I0021@ INDI
1 NAME Elizabeth /Shakespeare/
2 GIVN Elizabeth
2 SURN Shakespeare
1 SEX F
1 BIRT
2 DATE FEB 1608
1 CHR
2 DATE 21 FEB 1608
2 PLAC Stratford-upon-Avon
1 DEAT
2 DATE FEB 1670
1 FAMC @F006@
1 FAMS @F007@
1 FAMS @F008@
0 @I0022@ INDI
1 NAME Thomas /Nash/
2 GIVN Thomas
2 SURN Nash
1 SEX M
1 BIRT
2 DATE 1593
1 DEAT
2 DATE APR 1647
1 FAMS @F007@
0 @I0023@ INDI
1 NAME John /Barnard/
2 GIVN John
2 SURN Barnard
1 TITL Sir
1 SEX M
1 DEAT
2 DATE 1674
1 FAMS @F008@
0 @I0024@ INDI
1 NAME Thomas /Quiney/
2 GIVN Thomas
2 SURN Quiney
1 SEX M
1 BIRT
2 DATE 1589
1 DEAT
2 DATE ABT 1655
1 FAMS @F009@
1 FAMS @F011@
0 @I0025@ INDI
1 NAME Shakespeare /Quiney/
2 GIVN Shakespeare
2 SURN Quiney
1 SEX M
1 BIRT
2 DATE NOV 1616
1 CHR
2 DATE 23 NOV 1616
1 DEAT
2 DATE MAY 1617
1 BURI
2 DATE 08 MAY 1617
1 FAMC @F009@
0 @I0026@ INDI
1 NAME Richard /Quiney/
2 GIVN Richard
2 SURN Quiney
1 SEX M
1 BIRT
2 DATE FEB 1618
1 CHR
2 DATE 09 FEB 1618
1 DEAT
2 DATE FEB 1639
1 BURI
2 DATE 06 FEB 1639
1 FAMC @F009@
0 @I0027@ INDI
1 NAME Thomas /Quiney/
2 GIVN Thomas
2 SURN Quiney
1 SEX M
1 BIRT
2 DATE JAN 1620
1 CHR
2 DATE 23 JAN 1620
1 DEAT
2 DATE JAN 1639
1 BURI
2 DATE 28 JAN 1639
1 FAMC @F009@
0 @I0028@ INDI
1 NAME Richard /Hathaway/
2 GIVN Richard
2 SURN Hathaway
1 SEX M
1 DEAT
2 DATE SEP 1581
1 FAMS @F010@
0 @I0029@ INDI
1 NAME Margaret /Wheeler/
2 GIVN Margaret
2 SURN Wheeler
1 SEX F
1 DEAT
2 PLAC Died in childbirth
1 BURI
2 DATE 15 MAR 1616
1 FAMS @F011@
0 @I0030@ INDI
1 NAME Not named /Quiney/
2 GIVN Not named
2 SURN Quiney
1 SEX 
1 DEAT
2 PLAC Died in childbirth
1 BURI
2 DATE 15 MAR 1616
1 FAMC @F011@
0 @I0031@ INDI
1 NAME  /Unknown/
2 SURN Unknown
1 SEX F
1 FAMS @F003@
0 @F001@ FAM
1 HUSB @I0003@
1 WIFE @I0002@
1 MARR
2 DATE ABT 1557
1 CHIL @I0001@
1 CHIL @I0008@
1 CHIL @I0009@
1 CHIL @I0010@
1 CHIL @I0011@
1 CHIL @I0012@
1 CHIL @I0013@
1 CHIL @I0014@
0 @F002@ FAM
1 HUSB @I0001@
1 WIFE @I0004@
1 MARR
2 DATE NOV 1582
1 CHIL @I0005@
1 CHIL @I0006@
1 CHIL @I0007@
0 @F003@ FAM
1 HUSB @I0015@
1 WIFE @I0031@
1 CHIL @I0016@
1 CHIL @I0003@
0 @F004@ FAM
1 HUSB @I0016@
1 WIFE @I0017@
0 @F005@ FAM
1 HUSB @I0019@
1 WIFE @I0018@
1 CHIL @I0002@
0 @F006@ FAM
1 HUSB @I0020@
1 WIFE @I0005@
1 MARR
2 DATE 05 JUN 1607
2 PLAC Stratford-upon-Avon
1 CHIL @I0021@
0 @F007@ FAM
1 HUSB @I0022@
1 WIFE @I0021@
1 MARR
2 DATE 1626
0 @F008@ FAM
1 HUSB @I0023@
1 WIFE @I0021@
1 MARR
2 DATE 1649
0 @F009@ FAM
1 HUSB @I0024@
1 WIFE @I0007@
1 MARR
2 DATE 10 FEB 1616
2 PLAC Stratford-upon-Avon
1 CHIL @I0025@
1 CHIL @I0026@
1 CHIL @I0027@
0 @F010@ FAM
1 HUSB @I0028@
1 CHIL @I0004@
0 @F011@ FAM
1 HUSB @I0024@
1 WIFE @I0029@
1 MARR
2 PLAC Unmarried
1 CHIL @I0030@
0 TRLR
`

export const TudorGed = 
`
0 HEAD
1 SOUR PAF
2 NAME Personal Ancestral File
2 VERS 5.1.12.0
2 CORP The Church of Jesus Christ of Latter-day Saints
3 ADDR 50 East North Temple Street
4 CONT Salt Lake City, UT 84150
4 CONT USA
1 DEST Other
1 DATE 30 Aug 2003
2 TIME 10:33:45
1 FILE tudors.ged
1 GEDC
2 VERS 5.5
2 FORM LINEAGE-LINKED
1 CHAR ANSI
1 LANG English
1 SUBM @SUB1@
0 @SUB1@ SUBM
1 NAME Chris Phillips
1 ADDR Address withheld
2 CONT Address withheld
0 @I1@ INDI
1 NAME Henry /Tudor/
2 SURN Tudor
2 GIVN Henry
1 SEX M
1 BIRT
2 DATE 28 Jan 1456/1457
2 PLAC Pembroke Castle
2 SOUR @S1@
3 PAGE Volume 10, page 827
1 DEAT
2 DATE 21 Apr 1509
2 PLAC Richmond Palace
2 SOUR @S4@
3 PAGE 228
1 TITL King Henry VII
2 DATE FROM 22 Aug 1485
2 NOTE after defeating Richard III at the battle of Bosworth
2 SOUR @S1@
3 PAGE Volume 10, page 828
1 EVEN
2 TYPE Death mask
2 FILE http://www.marileecody.com/h7death.jpg
2 NOTE Link to Marilee Cody's "Tudor England" website
1 _UID A2220CEE05D7D711BA228E18B8357A36A187
1 FAMS @F1@
1 FAMC @F2@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 16:45:54
0 @I2@ INDI
1 NAME Elizabeth /Plantagenet/
2 SURN York
2 GIVN Elizabeth of
1 SEX F
1 BIRT
2 DATE 11 Feb 1465
2 PLAC Westminster Palace
2 SOUR @S5@
3 PAGE Volume 17, page 200
1 DEAT
2 DATE 11 Feb 1503
2 SOUR @S5@
3 PAGE Volume 17, page 203
1 EVEN
2 TYPE Coronation
2 DATE 25 Nov 1487
2 PLAC Westminster Abbey
2 SOUR @S4@
3 PAGE 78
1 _UID A6220CEE05D7D711BA228E18B8357A36A5C7
1 FAMS @F1@
1 FAMC @F3@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I3@ INDI
1 NAME Edmund /Tudor/
2 SURN Tudor
2 GIVN Edmund
1 SEX M
1 BIRT
2 DATE ABT 1430
2 PLAC Hadham, Hertfordshire
2 SOUR @S1@
3 PAGE Volume 10, page 825
1 DEAT
2 DATE 3 Nov 1456
2 PLAC Probably in Carmarthen Castle
2 SOUR @S1@
3 PAGE Volume 10, page 826
1 BURI
2 PLAC Greyfriars, Carmarthen
2 NOTE His body was removed in 1536 to St David's Cathedral
2 SOUR @S1@
3 PAGE Volume 10, page 826
1 TITL Knight
2 DATE FROM 15 Dec 1449
2 NOTE Knighted by his half-brother, Henry VI
2 SOUR @S1@
3 PAGE Volume 10, page 826
1 TITL Earl of Richmond
2 DATE FROM 23 Nov 1452
2 SOUR @S1@
3 PAGE Volume 10, page 826
1 _UID 2300C4FC09D7D711BA22444553540000B753
1 FAMS @F2@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I4@ INDI
1 NAME Margaret /Beaufort/
2 SURN Beaufort
2 GIVN Margaret
1 SEX F
1 BIRT
2 DATE 31 May 1443
2 PLAC Bletsoe
2 SOUR @S1@
3 PAGE Volume 4, page 207; volume 10, page 827
1 DEAT
2 DATE 29 Jun 1509
2 SOUR @S1@
3 PAGE Volume 4, page 207; volume 10, page 827
1 BURI
2 PLAC Westminster Abbey
2 SOUR @S1@
3 PAGE Volume 4, page 207; volume 10, page 827
1 _UID 2600C4FC09D7D711BA22444553540000BA83
1 FAMS @F4@
1 FAMS @F2@
1 FAMS @F5@
1 FAMS @F6@
1 FAMC @F7@
1 ASSO @I6@
2 RELA Margaret was John's only daughter and heir
2 SOUR @S1@
3 PAGE Volume 10, page 826
1 EVEN
2 TYPE Portrait
2 FILE http://www.marileecody.com/beaufort.jpg
2 NOTE Link to Marilee Cody's "Tudor England" website
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:56:26
0 @I5@ INDI
1 NAME John de la /Pole/
2 SURN Pole
2 GIVN John de la
1 SEX M
1 _UID 2A00C4FC09D7D711BA22444553540000BEC3
1 FAMS @F4@
1 TITL 2nd Duke of Suffolk
2 SOUR @S1@
3 PAGE Volume 10, page 826
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I6@ INDI
1 NAME John /Beaufort/
2 SURN Beaufort
2 GIVN John
1 SEX M
1 _UID 2E00C4FC09D7D711BA22444553540000C203
1 FAMS @F7@
1 TITL Duke of Somerset
2 SOUR @S1@
3 PAGE Volume 10, page 826
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I7@ INDI
1 NAME Margaret /Beauchamp/
2 SURN Beauchamp
2 GIVN Margaret
1 SEX F
1 _UID 3100C4FC09D7D711BA22444553540000C533
1 FAMS @F8@
1 FAMS @F7@
1 FAMC @F9@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I8@ INDI
1 NAME Oliver /St John/
2 SURN St John
2 GIVN Oliver
1 SEX M
1 _UID 3300C4FC09D7D711BA22444553540000C753
1 FAMS @F8@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I9@ INDI
1 NAME John /Beauchamp/
2 SURN Beauchamp
2 GIVN John
1 SEX M
1 _UID 3600C4FC09D7D711BA22444553540000CA83
1 FAMS @F9@
1 TITL Lord Beauchamp (of Bletsoe)
2 SOUR @S1@
3 PAGE Volume 4, page 207
1 RESI Bletsoe
2 SOUR @S1@
3 PAGE Volume 10, page 826
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I10@ INDI
1 NAME James /Stewart/
2 SURN Stewart
2 GIVN James
1 SEX M
1 BIRT
2 DATE 21 Feb 1506/1507
2 PLAC Holyrood House
2 SOUR @S2@
3 PAGE Volume 1, page 21
1 DEAT
2 DATE 27 Feb 1507/1508
2 SOUR @S2@
3 PAGE Volume 1, page 21
1 _UID E62E9C1D51DAD711BA22444553540000EC33
1 FAMC @F145@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 18:59:38
0 @I11@ INDI
1 NAME Henry /Stafford/
2 SURN Stafford
2 GIVN Henry
1 SEX M
1 DEAT
2 DATE 4 Oct 1471
2 SOUR @S1@
3 PAGE Volume 10, page 827
1 _UID 3B00C4FC09D7D711BA22444553540000CFD3
1 FAMS @F5@
1 FAMC @F10@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I12@ INDI
1 NAME Humphrey /Stafford/
2 SURN Stafford
2 GIVN Humphrey
1 SEX M
1 _UID 3E00C4FC09D7D711BA22444553540000D203
1 FAMS @F10@
1 TITL 1st Duke of Buckingham
2 SOUR @S1@
3 PAGE Volume 10, page 827
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I13@ INDI
1 NAME Thomas /Stanley/
2 SURN Stanley
2 GIVN Thomas
1 SEX M
1 BIRT
2 DATE ABT 1435
2 SOUR @S1@
3 PAGE Volume 4, page 205
1 DEAT
2 DATE 29 Jul 1504
2 PLAC Lathom
2 SOUR @S1@
3 PAGE Volume 4, page 207
1 BURI
2 PLAC Burscough Priory, Lancashire
2 SOUR @S1@
3 PAGE Volume 4, page 207
1 _UID 4100C4FC09D7D711BA22444553540000D533
1 FAMS @F11@
1 FAMS @F6@
1 TITL 2nd Lord Stanley
2 SOUR @S1@
3 PAGE Volume 10, page 827
1 TITL Earl of Derby
2 DATE FROM 27 Oct 1485
2 SOUR @S1@
3 PAGE Volume 4, page 206
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:55:32
0 @I14@ INDI
1 NAME Henry /Tudor/
2 SURN Tudor
2 GIVN Henry
1 SEX M
1 BIRT
2 DATE 28 Jun 1491
2 PLAC Greenwich
2 SOUR @S1@
3 PAGE Volume 3, page 443
1 CHR
2 PLAC Greenwich
2 SOUR @S1@
3 PAGE Volume 3, page 443
1 DEAT
2 DATE 28 Jan 1546/1547
2 SOUR @S1@
3 PAGE Volume 3, page 444
1 _UID 4400C4FC09D7D711BA22444553540000D863
1 FAMS @F12@
1 FAMS @F13@
1 FAMS @F14@
1 FAMS @F15@
1 FAMS @F16@
1 FAMS @F17@
1 FAMS @F18@
1 FAMS @F174@
1 FAMC @F1@
1 TITL Duke of Cornwall
2 DATE FROM 2 Apr 1502
2 NOTE Held to have succeeded to this title on the death of his brother Arthur
2 SOUR @S1@
3 PAGE Volume 3, page 442
1 TITL King Henry VIII
2 DATE FROM 22 Apr 509
2 SOUR @S1@
3 PAGE Volume 3, page 443
1 CHAN
2 DATE 28 Aug 2003
3 TIME 19:05:25
0 @I15@ INDI
1 NAME Catherine of /Aragon/
2 SURN Aragon
2 GIVN Catherine of
1 SEX F
1 BIRT
2 DATE 5 Dec 1485
2 PLAC Alcal� de Henares, near Madrid
2 SOUR @S1@
3 PAGE Volume 3, page 442
1 DEAT
2 DATE 6 Jan 1535/1536
2 PLAC Kimbolton Castle
2 SOUR @S1@
3 PAGE Volume 3, page 442
1 BURI
2 PLAC Peterborough Abbey
2 SOUR @S1@
3 PAGE Volume 3, page 442
1 _UID 4600C4FC09D7D711BA22444553540000DA83
1 FAMS @F19@
1 FAMS @F12@
1 FAMC @F20@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:06:24
0 @I16@ INDI
1 NAME Anne /Boleyn/
2 SURN Boleyn
2 GIVN Anne
1 SEX F
1 DEAT
2 DATE 19 May 1536
2 PLAC Tower Green, London
2 SOUR @S1@
3 PAGE Volume 10, page 404
1 BURI
2 PLAC St Peter's in the Tower
2 SOUR @S1@
3 PAGE Volume 10, pages 404, 405
1 _UID 4900C4FC09D7D711BA22444553540000DDB3
1 FAMS @F13@
1 FAMC @F21@
1 TITL Marchioness of Pembroke
2 DATE FROM 1 Sep 1532
2 SOUR @S1@
3 PAGE Volume 10, page 404
1 TITL Queen Consort
2 DATE FROM 1 Jun 1533
3 NOTE (crowned)
2 SOUR @S1@
3 PAGE Volume 10, page 404
1 EVEN
2 TYPE Sent to the Tower of London
2 DATE 2 May 1536
2 SOUR @S1@
3 PAGE Volume 10, page 404
1 EVEN
2 TYPE Tried
2 DATE 15 May 1536
2 PLAC Tower of London
2 SOUR @S1@
3 PAGE Volume 10, page 404
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:16:30
0 @I17@ INDI
1 NAME Anne of /Cleves/
2 SURN Cleves
2 GIVN Anne of
1 SEX F
1 BIRT
2 DATE 22 Sep 1515
2 SOUR @S5@
3 PAGE Volume 1, page 429
1 DEAT
2 DATE 16 Jul 1557
2 SOUR @S5@
3 PAGE Volume 1, page 431
1 BURI
2 DATE 3 Aug 1557
2 PLAC Westminster Abbey
2 SOUR @S5@
3 PAGE Volume 1, page 431
1 EVEN
2 TYPE Portrait
2 FILE http://www.marileecody.com/cleves-portraits.html
2 NOTE Link to Marilee Cody's "Tudor England" website
1 _UID 4C00C4FC09D7D711BA22444553540000E0E3
1 FAMS @F15@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I18@ INDI
1 NAME Jane /Seymour/
2 SURN Seymour
2 GIVN Jane
1 SEX F
1 DEAT
2 DATE 15 Oct 1537
2 SOUR @S1@
3 PAGE Volume 3, page 444
1 _UID 4F00C4FC09D7D711BA22444553540000E313
1 FAMS @F14@
1 FAMC @F22@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 19:06:31
0 @I19@ INDI
1 NAME Catherine /Howard/
2 SURN Howard
2 GIVN Catherine
1 SEX F
1 DEAT
2 DATE 13 Feb 1541/2
2 PLAC Tower of London
2 CAUS beheading
2 SOUR @S4@
3 PAGE 419
1 _UID 5200C4FC09D7D711BA22444553540000E643
1 FAMS @F16@
1 FAMC @F23@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I20@ INDI
1 NAME Catherine /Parr/
2 SURN Parr
2 GIVN Catherine
1 SEX F
1 DEAT
2 DATE 5 Sep 1548
2 PLAC Sudeley Castle
2 CAUS Puerperal fever
2 NOTE without male issue
2 SOUR @S1@
3 PAGE Volume 11, page 639
1 BURI
2 PLAC Sudeley Castle
2 SOUR @S1@
3 PAGE Volume 11, page 639
1 _UID 5500C4FC09D7D711BA22444553540000E973
1 FAMS @F24@
1 FAMS @F25@
1 FAMS @F17@
1 FAMS @F26@
1 FAMC @F27@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:32:31
0 @I21@ INDI
1 NAME Elizabeth /Blount/
2 SURN Blount
2 GIVN Elizabeth
1 SEX F
1 _UID 5800C4FC09D7D711BA22444553540000ECA3
1 FAMS @F18@
1 OCCU Maid of Honour to Queen Catherine
2 DATE BET 1512 AND 1514
2 SOUR @S1@
3 PAGE Volume 10, page 829
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I22@ INDI
1 NAME Henry /Fitzroy/
2 SURN Fitzroy
2 GIVN Henry
1 SEX M
1 NOTE Illegitimate
1 BIRT
2 DATE 1519
2 PLAC ?Blackmore, Essex
2 SOUR @S1@
3 PAGE Volume 10, page 829
1 DEAT
2 DATE 22 Jul 1536
2 CAUS consumption
2 NOTE without issue
2 SOUR @S1@
3 PAGE Volume 10, page 830
1 BURI
2 PLAC Thetford
2 SOUR @S1@
3 PAGE Volume 10, page 830
1 _UID 5B00C4FC09D7D711BA22444553540000EFD3
1 FAMS @F28@
1 FAMC @F18@
1 TITL Knight of the Garter
2 DATE FROM 7 Jun 1525
3 NOTE (nominated)
2 DATE 25 Jun 1525
3 NOTE (instituted)
2 SOUR @S1@
3 PAGE Volume 10, page 829
1 TITL Earl of Nottingham and Duke of Richmond and Somerset
2 DATE FROM 18 Jun 1525
2 PLAC Bridewell
2 SOUR @S1@
3 PAGE Volume 10, page 829
1 EVEN
2 TYPE Portrait
2 FILE http://www.marileecody.com/fitzroy.jpg
2 NOTE Link to Marilee Cody's "Tudor England" website
1 CHAN
2 DATE 28 Aug 2003
3 TIME 11:13:18
0 @I23@ INDI
1 NAME Mary /Howard/
2 SURN Howard
2 GIVN Mary
1 SEX F
1 DEAT
2 DATE 9 Dec 1557
2 NOTE without issue
2 SOUR @S1@
3 PAGE Volume 10, page 830
1 _UID 5D00C4FC09D7D711BA22444553540000F1F3
1 FAMS @F28@
1 FAMC @F29@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 11:14:20
0 @I24@ INDI
1 NAME Thomas /Howard/
2 SURN Howard
2 GIVN Thomas
1 SEX M
1 BIRT
2 DATE 1473
2 SOUR @S1@
3 PAGE Volume 9, page 615
1 DEAT
2 DATE 25 Aug 1554
2 PLAC Kenninghall, Norfolk
2 SOUR @S1@
3 PAGE Volume 9, page 619
1 BURI
2 DATE 2 Oct 1554
2 PLAC Framlingham
2 SOUR @S1@
3 PAGE Volume 9, page 619
1 _UID 6000C4FC09D7D711BA22444553540000F423
1 FAMS @F30@
1 FAMS @F29@
1 FAMC @F31@
1 TITL Lord Howard
2 DATE FROM 1483 TO 1514
2 SOUR @S1@
3 PAGE Volume 9, page 615
1 TITL Earl of Surrey
2 DATE FROM 1 Feb 1513/4
2 NOTE Created for his life
2 SOUR @S1@
3 PAGE Volume 9, page 616
1 TITL Earl Marshal of England
2 DATE FROM 28 May 1533
2 SOUR @S1@
3 PAGE Volume 9, page 617
1 TITL Duke of Norfolk
2 SOUR @S1@
3 PAGE Volume 9, page 614
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:07:15
0 @I25@ INDI
1 NAME Elizabeth /Stafford/
2 SURN Stafford
2 GIVN Elizabeth
1 SEX F
1 BIRT
2 DATE ABT 1497
2 SOUR @S1@
3 PAGE Volume 9, page 620
1 DEAT
2 DATE 30 Nov 1558
2 PLAC Lambeth
2 SOUR @S1@
3 PAGE Volume 9, page 620
1 BURI
2 DATE 7 Dec 1558
2 PLAC Howard Chapel, Lambeth
2 SOUR @S1@
3 PAGE Volume 9, page 620
1 _UID 6300C4FC09D7D711BA22444553540000F753
1 FAMS @F29@
1 FAMC @F32@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:07:43
0 @I26@ INDI
1 NAME Edward /Stafford/
2 SURN Stafford
2 GIVN Edward
1 SEX M
1 _UID 6500C4FC09D7D711BA22444553540000F973
1 FAMS @F32@
1 TITL Duke of Buckingham
2 SOUR @S1@
3 PAGE Volume 10, page 830
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I27@ INDI
1 NAME Edmund /Tudor/
2 SURN Tudor
2 GIVN Edmund
1 SEX M
1 BIRT
2 DATE Feb 1498/1499
3 NOTE 21 or 22 February
2 PLAC Greenwich
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 58
1 CHR
2 DATE 24 Feb 1498/1499
2 PLAC Greyfriars, Greenwich
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 58
1 DEAT
2 DATE 19 Jun 1500
2 PLAC Bishop's Hatfield, Hertfordshire
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 59
1 BURI
2 DATE 23 Jun 1500
2 PLAC Westminster Abbey
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 59
1 _UID 6800C4FC09D7D711BA22444553540000FCA3
1 FAMC @F1@
1 TITL Duke of Somerset
2 NOTE Said to have been so created, but no enrolment of a patent of such creation is to be found
2 SOUR @S1@
3 PAGE Volume 12, part 1, pages 58, 59
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:03:33
0 @I28@ INDI
1 NAME Arthur /Tudor/
2 SURN Tudor
2 GIVN Arthur
1 SEX M
1 BIRT
2 DATE 20 Sep 1486
2 PLAC St Swithin's Priory, Winchester
2 SOUR @S1@
3 PAGE Volume 3, page 441
1 CHR
2 DATE 24 Sep 1486
2 PLAC Winchester Cathedral
2 SOUR @S1@
3 PAGE Volume 3, page 441
1 DEAT
2 DATE 2 Apr 1502
2 PLAC Ludlow Castle, Shropshire
2 NOTE in his father's lifetime, without issue
2 SOUR @S1@
3 PAGE Volume 3, page 442
1 BURI
2 PLAC Worcester Cathedral
2 SOUR @S1@
3 PAGE Volume 3, page 442
1 _UID 6A00C4FC09D7D711BA22444553540000FEC3
1 FAMS @F19@
1 FAMC @F1@
1 TITL Duke of Cornwall
2 SOUR @S1@
3 PAGE Volume 3, page 441
1 TITL Knight of the Bath, Prince of Wales and Earl of Chester
2 DATE FROM 29 Nov 1489
2 SOUR @S1@
3 PAGE Volume 3, pages 441, 442
1 TITL Knight of the Garter
2 NOTE (instituted)
2 DATE 8 May 1491
2 SOUR @S1@
3 PAGE Volume 3, page 442
1 EVEN
2 TYPE Portrait
2 FILE http://www.marileecody.com/arthur2.jpg
2 NOTE Link to Marilee Cody's "Tudor England" website
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:05:12
0 @I29@ INDI
1 NAME Ferdinand of /Aragon/
2 SURN Aragon
2 GIVN Ferdinand of
1 SEX M
1 _UID 6D00C4FC09D7D711BA2244455354000001F3
1 FAMS @F20@
1 TITL King Ferdinand V of Castile and Aragon
2 SOUR @S1@
3 PAGE Volume 3, page 442
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I30@ INDI
1 NAME Isabella of /Castile/
2 SURN Castile
2 GIVN Isabella of
1 SEX F
1 _UID 7000C4FC09D7D711BA224445535400000423
1 FAMS @F20@
1 FAMC @F33@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I31@ INDI
1 NAME John of /Castile/
2 SURN Castile
2 GIVN John of
1 SEX M
1 TITL King John II of Castile and Leon
1 _UID 7200C4FC09D7D711BA224445535400000643
1 FAMS @F33@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I32@ INDI
1 NAME Henry /Tudor/
2 SURN Tudor
2 GIVN Henry
1 SEX M
1 BIRT
2 DATE 1 Jan 1510/1511
2 PLAC Richmond, Surrey
2 SOUR @S1@
3 PAGE Volume 3, page 443
1 DEAT
2 DATE 22 Feb 1510/1511
2 PLAC Richmond, Surrey
2 SOUR @S1@
3 PAGE Volume 3, page 443
1 BURI
2 PLAC Westminster Abbey
2 SOUR @S1@
3 PAGE Volume 3, page 443
1 _UID 7500C4FC09D7D711BA224445535400000973
1 FAMC @F12@
1 TITL Duke of Cornwall
2 SOUR @S1@
3 PAGE Volume 3, page 443
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:08:19
0 @I33@ INDI
1 NAME ... /Tudor/
2 SURN Tudor
2 GIVN [Henry?]
1 SEX M
1 BIRT
2 DATE Nov 1514
2 SOUR @S1@
3 PAGE Volume 3, page 444
1 DEAT
2 DATE Nov 1514
2 SOUR @S1@
3 PAGE Volume 3, page 443
1 _UID 7700C4FC09D7D711BA224445535400000B93
1 FAMC @F12@
1 TITL Duke of Cornwall
2 SOUR @S1@
3 PAGE Volume 3, page 444
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:08:46
0 @I34@ INDI
1 NAME Edward /Tudor/
2 SURN Tudor
2 GIVN Edward
1 SEX M
1 BIRT
2 DATE 12 Oct 1537
2 PLAC Hampton Court , Middlesex
2 SOUR @S1@
3 PAGE Volume 3, page 444
1 CHR
2 DATE 15 Oct 1537
2 PLAC Hampton Court, Middlesex
2 SOUR @S1@
3 PAGE Volume 3, page 444
1 DEAT 
2 DATE 6 Jul 1553
2 SOUR @S4@
3 PAGE 526
1 _UID 7900C4FC09D7D711BA224445535400000DB3
1 FAMC @F14@
1 TITL Duke of Cornwall
2 SOUR @S1@
3 PAGE Volume 3, page 444
1 TITL King Edward VI
2 DATE FROM 28 Jan 1546/7
2 SOUR @S1@
3 PAGE Volume 3, page 444
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:09:24
0 @I35@ INDI
1 NAME John /Seymour/
2 SURN Seymour
2 GIVN John
1 SEX M
1 DEAT
2 DATE 21 Dec 1536
2 SOUR @S1@
3 PAGE Volume 12, part 1, pages 59, 60
1 RESI Wolf Hall, Wiltshire
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 59
1 _UID 7B00C4FC09D7D711BA224445535400000FD3
1 FAMS @F22@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:27:32
0 @I36@ INDI
1 NAME Thomas /Boleyn/
2 SURN Boleyn
2 GIVN Thomas
1 SEX M
1 _UID 7E00C4FC09D7D711BA224445535400001203
1 FAMS @F21@
1 TITL Earl of Wiltshire, Earl of Ormond [Ireland] and Viscount Rochford
2 SOUR @S1@
3 PAGE Volume 10, page 403
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I37@ INDI
1 NAME Elizabeth /Howard/
2 SURN Howard
2 GIVN Elizabeth
1 SEX F
1 _UID 8100C4FC09D7D711BA224445535400001533
1 FAMS @F21@
1 FAMC @F31@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I38@ INDI
1 NAME Thomas /Howard/
2 SURN Howard
2 GIVN Thomas
1 SEX M
1 BIRT
2 DATE 1443
2 PLAC Stoke Neyland
2 SOUR @S1@
3 PAGE Volume 9, page 612
1 DEAT
2 DATE 21 May 1524
2 PLAC Framlingham Castle
2 SOUR @S1@
3 PAGE Volume 9, page 615
1 BURI
2 DATE 26 Jun 1524
2 PLAC Thetford Abbey
2 SOUR @S1@
3 PAGE Volume 9, page 615
1 _UID 8300C4FC09D7D711BA224445535400001753
1 FAMS @F31@
1 FAMS @F34@
1 TITL Earl of Surrey
2 DATE FROM 28 Jun 1483 TO 1 Feb 1513/4
2 SOUR @S1@
3 PAGE Volume 9, page 613
1 TITL Earl Marshal of England
2 DATE FROM 10 Jul 1510
2 NOTE Created for life
2 SOUR @S1@
3 PAGE Volume 9, page 614
1 TITL Duke of Norfolk
2 DATE FROM 1 Feb 1513/4
2 SOUR @S1@
3 PAGE Volume 9, page 614
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:03:34
0 @I39@ INDI
1 NAME Mary /Tudor/
2 SURN Tudor
2 GIVN Mary
1 SEX F
1 BIRT
2 DATE 18 Mar 1494/1495
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 459
1 DEAT
2 DATE 25 Jun 1533
2 PLAC Westhorpe Hall, Suffolk
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 459
1 BURI
2 DATE 22 Jul 1533
2 PLAC Bury St Edmunds Abbey
2 NOTE Later removed to St Mary's church, Bury St Edmunds
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 459
1 _UID 8600C4FC09D7D711BA224445535400001A83
1 FAMS @F35@
1 FAMS @F36@
1 FAMC @F1@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:27:04
0 @I40@ INDI
1 NAME Charles /Brandon/
2 SURN Brandon
2 GIVN Charles
1 SEX M
1 BIRT
2 DATE ABT 1484
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 454
1 DEAT
2 DATE 22 Aug 1545
2 PLAC Guildford Palace, Surrey
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 460
1 BURI
2 PLAC St George's Chapel, Windsor
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 460
1 _UID 8800C4FC09D7D711BA224445535400001CA3
1 FAMS @F37@
1 FAMS @F38@
1 FAMS @F36@
1 FAMS @F39@
1 FAMC @F40@
1 TITL Viscount Lisle
2 DATE FROM 15 May 1513
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 455
1 TITL Duke of Suffolk
2 DATE FROM 1 Feb 1513/4
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 455
1 EVEN
2 TYPE Received wardship of Elizabeth, Baroness Lisle in her own right, with whom he made a contract of marriage (never fulfilled)
2 DATE 21 Apr 1513
2 SOUR @S1@
3 PAGE Volume 12, part 1, pages 455, 459
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:29:37
0 @I41@ INDI
1 NAME William /Brandon/
2 SURN Brandon
2 GIVN William
1 SEX M
1 DEAT
2 DATE 22 Aug 1485
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 454
1 _UID 8B00C4FC09D7D711BA224445535400001FD3
1 FAMS @F40@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:18:18
0 @I42@ INDI
1 NAME Elizabeth /Bruyn/
2 SURN Bruyn
2 GIVN Elizabeth
1 SEX F
1 DEAT
2 DATE Mar 1493/1494
3 NOTE 7 or 26 March
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 454
1 _UID 8E00C4FC09D7D711BA224445535400002203
1 FAMS @F40@
1 FAMC @F41@
1 ASSO @I43@
2 RELA Elizabeth was Henry's daughter and coheir
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 454
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:18:49
0 @I43@ INDI
1 NAME Henry /Bruyn/
2 SURN Bruyn
2 GIVN Henry
1 SEX M
1 _UID 9000C4FC09D7D711BA224445535400002423
1 FAMS @F41@
1 RESI South Ockenden, Essex
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 454
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I44@ INDI
1 NAME Anne /Browne/
2 SURN Browne
2 GIVN Anne
1 SEX F
1 DEAT
2 DATE BET 1511 AND 1512
2 NOTE without male issue
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 459
1 _UID 9300C4FC09D7D711BA224445535400002753
1 FAMS @F37@
1 FAMC @F42@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 15:20:46
0 @I45@ INDI
1 NAME Margaret /Neville/
2 SURN Neville
2 GIVN Margaret
1 SEX F
1 BIRT
2 DATE 1466
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 458
1 _UID 9600C4FC09D7D711BA224445535400002A83
1 FAMS @F43@
1 FAMS @F38@
1 FAMC @F44@
1 ASSO @I46@
2 RELA Margaret was John's 3d daughter and coheir
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 458
1 CHAN
2 DATE 28 Aug 2003
3 TIME 19:10:15
0 @I46@ INDI
1 NAME John /Neville/
2 SURN Neville
2 GIVN John
1 SEX M
1 _UID 9900C4FC09D7D711BA224445535400002DB3
1 FAMS @F44@
1 TITL Marquess of Montagu
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 458
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I47@ INDI
1 NAME Isabella /Ingaldesthorpe/
2 SURN Ingaldesthorpe
2 GIVN Isabella
1 SEX F
1 _UID 9C00C4FC09D7D711BA2244455354000030E3
1 FAMS @F44@
1 FAMC @F45@
1 ASSO @I48@
2 RELA Isabella was Edmund's daughter and coheir
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 458
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I48@ INDI
1 NAME Edmund /Ingaldesthorpe/
2 SURN Ingaldesthorpe
2 GIVN Edmund
1 SEX M
1 _UID 9E00C4FC09D7D711BA224445535400003203
1 FAMS @F45@
1 RESI Borough Green, Cambridgeshire
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 458
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I49@ INDI
1 NAME John /Mortimer/
2 SURN Mortimer
2 GIVN John
1 SEX M
1 DEAT
2 DATE BEF 12 Nov 1504
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 458
1 _UID A100C4FC09D7D711BA224445535400003533
1 FAMS @F43@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:22:02
0 @I50@ INDI
1 NAME Anthony /Browne/
2 SURN Browne
2 GIVN Anthony
1 SEX M
1 _UID A400C4FC09D7D711BA224445535400003863
1 FAMS @F42@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I51@ INDI
1 NAME Louis of /Valois/
2 SURN Valois
2 GIVN Louis of
1 SEX M
1 TITL King Louis XII of France
1 DEAT
2 DATE 1 Jan 1514/1515
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 459
1 _UID A700C4FC09D7D711BA224445535400003B93
1 FAMS @F35@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:26:19
0 @I52@ INDI
1 NAME Catherine /Willoughby/
2 SURN Willoughby
2 GIVN Catherine
1 SEX F
1 BIRT
2 DATE 22 Mar 1519/1520
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 460
1 CHR
2 DATE 26 Mar 1519/1520
2 PLAC Parham, Suffolk
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 460
1 DEAT
2 DATE 19 Sep 1580
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 460
1 BURI
2 PLAC Spilsby, Lincolnshire
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 460
1 _UID AA00C4FC09D7D711BA224445535400003EC3
1 FAMS @F39@
1 FAMS @F46@
1 FAMC @F47@
1 TITL Baroness Willoughby de Eresby in her own right
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 460
1 CHAN
2 DATE 28 Aug 2003
3 TIME 19:11:30
0 @I53@ INDI
1 NAME William /Willoughby/
2 SURN Willoughby
2 GIVN William
1 SEX M
1 _UID AD00C4FC09D7D711BA2244455354000041F3
1 FAMS @F47@
1 TITL Lord Willoughby de Eresby
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 460
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I54@ INDI
1 NAME Mary de /Salinas/
2 SURN Salinas
2 GIVN Mary de
1 SEX F
1 _UID B000C4FC09D7D711BA224445535400004423
1 FAMS @F47@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I56@ INDI
1 NAME Richard /Bertie/
2 SURN Bertie
2 GIVN Richard
1 SEX M
1 DEAT
2 DATE 9 Apr 1582
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 460
1 BURI
2 PLAC Spilsby, Lincolnshire
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 460
1 _UID B500C4FC09D7D711BA224445535400004973
1 FAMS @F46@
1 OCCU Sometime MP for county Lincoln
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 460
1 ASSO @I52@
2 RELA Richard was Catherine's gentleman usher
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 460
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:30:12
0 @I57@ INDI
1 NAME Archibald /Douglas/
2 SURN Douglas
2 GIVN Archibald
1 SEX M
1 BIRT
2 DATE ABT 1490
2 SOUR @S1@
3 PAGE Volume 1, page 157
1 DEAT
2 DATE Jan 1556/1557
2 PLAC Tantallon Castle
2 CAUS Erysipelas
2 SOUR @S1@
3 PAGE Volume 1, page 158
1 BURI
2 PLAC Abernethy
2 SOUR @S1@
3 PAGE Volume 1, page 158
1 _UID B800C4FC09D7D711BA224445535400004CA3
1 FAMS @F49@
1 FAMS @F50@
1 FAMS @F51@
1 FAMC @F52@
1 TITL Earl of Angus [Scotland]
2 SOUR @S1@
3 PAGE Volume 1, page 157
1 ASSO @I58@
2 RELA Archibald was George's son and heir
2 SOUR @S1@
3 PAGE Volume 1, page 157
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:38:05
0 @I58@ INDI
1 NAME George /Douglas/
2 SURN Douglas
2 GIVN George
1 SEX M
1 _UID BA00C4FC09D7D711BA224445535400004EC3
1 FAMS @F52@
1 TITL Styled Master of Angus or Lord Douglas
2 SOUR @S1@
3 PAGE Volume 1, page 157
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I59@ INDI
1 NAME Elizabeth /Drummond/
2 SURN Drummond
2 GIVN Elizabeth
1 SEX F
1 _UID BD00C4FC09D7D711BA2244455354000051F3
1 FAMS @F53@
1 FAMS @F52@
1 FAMC @F54@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I60@ INDI
1 NAME John /Drummond/
2 SURN Drummond
2 GIVN John
1 SEX M
1 _UID BF00C4FC09D7D711BA224445535400005313
1 FAMS @F54@
1 TITL 1st Lord Drummond
2 SOUR @S1@
3 PAGE Volume 1, page 157
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I61@ INDI
1 NAME David /Fleming/
2 SURN Fleming
2 GIVN David
1 SEX M
1 _UID C200C4FC09D7D711BA224445535400005643
1 FAMS @F53@
1 RESI Monycabo
2 SOUR @S1@
3 PAGE Volume 1, page 157
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I62@ INDI
1 NAME Margaret /Hepburn/
2 SURN Hepburn
2 GIVN Margaret
1 SEX F
1 DEAT
2 DATE 1513
2 NOTE without surviving issue
2 SOUR @S1@
3 PAGE Volume 1, page 157
2 SOUR @S2@
3 PAGE Volume 2, page 155
1 _UID C500C4FC09D7D711BA224445535400005973
1 FAMS @F49@
1 FAMC @F55@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:33:59
0 @I63@ INDI
1 NAME Patrick /Hepburn/
2 SURN Hepburn
2 GIVN Patrick
1 SEX M
1 _UID C800C4FC09D7D711BA224445535400005CA3
1 FAMS @F55@
1 TITL 1st Earl of Bothwell
2 SOUR @S1@
3 PAGE Volume 1, page 157
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I64@ INDI
1 NAME Janet /Douglas/
2 SURN Douglas
2 GIVN Janet
1 SEX F
1 _UID CB00C4FC09D7D711BA224445535400005FD3
1 FAMS @F55@
1 FAMC @F56@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I65@ INDI
1 NAME James /Douglas/
2 SURN Douglas
2 GIVN James
1 SEX M
1 _UID CD00C4FC09D7D711BA2244455354000061F3
1 FAMS @F56@
1 TITL 1st Earl of Morton
2 SOUR @S1@
3 PAGE Volume 1, page 157
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I66@ INDI
1 NAME Margaret /Tudor/
2 SURN Tudor
2 GIVN Margaret
1 SEX F
1 BIRT
2 DATE 28 Nov 1489
2 PLAC Westminster
2 SOUR @S1@
3 PAGE Volume 1, page 158; volume 8, page 683
1 CHR
2 DATE 30 Nov 1489
2 PLAC Westminster Abbey
2 SOUR @S1@
3 PAGE Volume 8, page 683
1 DEAT
2 DATE 18 Oct 1541
2 PLAC Methven
2 CAUS Palsy
2 SOUR @S1@
3 PAGE Volume 1, page 158; volume 8, page 683
2 SOUR @S2@
3 PAGE Volume 1, page 21
1 BURI
2 PLAC St John's Monastery, Perth
2 SOUR @S1@
3 PAGE Volume 1, page 158
2 SOUR @S2@
3 PAGE Volume 1, pages 21, 22
1 _UID D000C4FC09D7D711BA224445535400006423
1 FAMS @F145@
1 FAMS @F50@
1 FAMS @F57@
1 FAMC @F1@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:04:01
0 @I67@ INDI
1 NAME Margaret /Maxwell/
2 SURN Maxwell
2 GIVN Margaret
1 SEX F
1 DEAT
2 DATE 31 Jan 1593/1594
2 SOUR @S1@
3 PAGE Volume 1, page 158; volume 14, page 27
1 _UID D300C4FC09D7D711BA224445535400006753
1 FAMS @F51@
1 FAMS @F58@
1 FAMC @F59@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 12:38:59
0 @I68@ INDI
1 NAME Robert /Maxwell/
2 SURN Maxwell
2 GIVN Robert
1 SEX M
1 _UID D600C4FC09D7D711BA224445535400006A83
1 FAMS @F59@
1 TITL 4th Lord Maxwell
2 SOUR @S1@
3 PAGE Volume 1, page 158
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I69@ INDI
1 NAME Janet /Douglas/
2 SURN Douglas
2 GIVN Janet
1 SEX F
1 _UID D900C4FC09D7D711BA224445535400006DB3
1 FAMS @F59@
1 FAMC @F60@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I70@ INDI
1 NAME William /Douglas/
2 SURN Douglas
2 GIVN William
1 SEX M
1 _UID DB00C4FC09D7D711BA224445535400006FD3
1 FAMS @F60@
1 RESI Drumlanrig
2 SOUR @S1@
3 PAGE Volume 1, page 158
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I71@ INDI
1 NAME William /Baillie/
2 SURN Baillie
2 GIVN William
1 SEX M
1 _UID DE00C4FC09D7D711BA224445535400007203
1 FAMS @F58@
1 RESI Lamington
2 SOUR @S1@
3 PAGE Volume 1, page 158
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I72@ INDI
1 NAME Henry /Stewart/
2 SURN Stewart
2 GIVN Henry
1 SEX M
1 DEAT
2 DATE (Soon after 10 October 1551)
2 SOUR @S1@
3 PAGE Volume 8, page 683
1 _UID 82E9F64C29D7D711BA22AAFF03D374369A97
1 FAMS @F61@
1 FAMS @F57@
1 FAMS @F62@
1 FAMC @F63@
1 TITL Lord Methven
2 DATE FROM 17 Jul 1528
2 SOUR @S1@
3 PAGE Volume 8, page 683
1 NOTE @N1@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 15:22:06
0 @I73@ INDI
1 NAME Andrew /Stewart/
2 SURN Stewart
2 GIVN Andrew
1 SEX M
1 _UID 85E9F64C29D7D711BA22AAFF03D374369DC7
1 FAMS @F63@
1 TITL Lord Avondale
2 SOUR @S1@
3 PAGE Volume 8, page 682
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I74@ INDI
1 NAME Margaret /Kennedy/
2 SURN Kennedy
2 GIVN Margaret
1 SEX F
1 _UID 88E9F64C29D7D711BA22AAFF03D37436A0F7
1 FAMS @F63@
1 FAMC @F64@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I75@ INDI
1 NAME John /Kennedy/
2 SURN Kennedy
2 GIVN John
1 SEX M
1 _UID 8AE9F64C29D7D711BA22AAFF03D37436A217
1 FAMS @F64@
1 TITL 2nd Lord Kennedy
2 SOUR @S1@
3 PAGE Volume 8, page 682
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I76@ INDI
1 NAME ... /Leslie/
2 SURN Leslie
1 SEX F
1 _UID 8DE9F64C29D7D711BA22AAFF03D37436A547
1 FAMS @F61@
1 NOTE @N1@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 13:39:11
0 @I77@ INDI
1 NAME Janet /Stewart/
2 SURN Stewart
2 GIVN Janet
1 SEX F
1 _UID 90E9F64C29D7D711BA22AAFF03D37436A877
1 FAMS @F65@
1 FAMS @F66@
1 FAMS @F62@
1 FAMS @F67@
1 FAMS @F68@
1 FAMC @F69@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I78@ INDI
1 NAME Hugh /Kennedy/
2 SURN Kennedy
2 GIVN Hugh
1 SEX M
1 _UID 93E9F64C29D7D711BA22AAFF03D37436ABA7
1 FAMS @F66@
1 RESI Girvanmains
2 SOUR @S1@
3 PAGE Volume 8, page 683
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I79@ INDI
1 NAME Alexander /Gordon/
2 SURN Gordon
2 GIVN Alexander
1 SEX M
1 _UID 96E9F64C29D7D711BA22AAFF03D37436AED7
1 FAMS @F65@
1 TITL Master of Sutherland
2 SOUR @S1@
3 PAGE Volume 8, page 683
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I80@ INDI
1 NAME John /Stewart/
2 SURN Stewart
2 GIVN John
1 SEX M
1 _UID 99E9F64C29D7D711BA22AAFF03D37436B107
1 FAMS @F69@
1 TITL 2nd Earl of Atholl
2 SOUR @S1@
3 PAGE Volume 8, page 683
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I81@ INDI
1 NAME Janet /Campbell/
2 SURN Campbell
2 GIVN Janet
1 SEX F
1 _UID 9CE9F64C29D7D711BA22AAFF03D37436B437
1 FAMS @F69@
1 FAMC @F70@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I82@ INDI
1 NAME Archibald /Campbell/
2 SURN Campbell
2 GIVN Archbald
1 SEX M
1 _UID 9EE9F64C29D7D711BA22AAFF03D37436B657
1 FAMS @F70@
1 TITL 2nd Earl of Argyll
2 SOUR @S1@
3 PAGE Volume 8, page 683
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I83@ INDI
1 NAME Patrick /Ruthven/
2 SURN Ruthven
2 GIVN Patrick
1 SEX M
1 DEAT
2 DATE 13 Jun 1566
2 SOUR @S1@
3 PAGE Volume 8, page 683
1 _UID A1E9F64C29D7D711BA22AAFF03D37436B987
1 FAMS @F67@
1 TITL 3rd Lord Ruthven
2 SOUR @S1@
3 PAGE Volume 8, page 683
1 CHAN
2 DATE 28 Aug 2003
3 TIME 13:43:56
0 @I84@ INDI
1 NAME James /Gray/
2 SURN Gray
2 GIVN James
1 SEX M
1 _UID A4E9F64C29D7D711BA22AAFF03D37436BCB7
1 FAMS @F68@
1 FAMC @F144@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I85@ INDI
1 NAME Edward /Plantagenet/
2 SURN York
2 GIVN Edward of
1 SEX M
1 BIRT
2 DATE 28 Apr 1442
2 PLAC Rouen
2 SOUR @S1@
3 PAGE Volume 5, page 361
1 CHR
2 PLAC Rouen Cathedral
2 SOUR @S1@
3 PAGE Volume 5, page 361
1 DEAT
2 DATE 9 Apr 1483
2 PLAC Westminster
2 SOUR @S1@
3 PAGE Volume 5, page 361
1 BURI
2 DATE 18 Apr 1483
2 PLAC St George's Chapel, Windsor
2 SOUR @S1@
3 PAGE Volume 5, page 361
1 _UID A7E9F64C29D7D711BA22AAFF03D37436BFE7
1 FAMS @F3@
1 FAMS @F71@
1 TITL King Edward IV
1 EVEN
2 TYPE Coronation
2 DATE 28 Jun 1461
2 PLAC Westminster
2 SOUR @S1@
3 PAGE Volume 5, page 361
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:11:13
0 @I86@ INDI
1 NAME Elizabeth /Wydvill/
2 SURN Wydvill
2 GIVN Elizabeth
1 SEX F
1 DEAT
2 DATE Jun 1492
3 NOTE 7 or 8 June
2 PLAC Bermondsey Abbey
2 SOUR @S1@
3 PAGE Volume 5, page 362
1 BURI
2 DATE 12 Jun 1492
2 PLAC St George's Chapel, Windsor
2 SOUR @S1@
3 PAGE Volume 5, page 362
1 _UID AAE9F64C29D7D711BA22AAFF03D37436C217
1 FAMS @F72@
1 FAMS @F3@
1 FAMC @F73@
1 EVEN
2 TYPE Coronation
2 DATE 26 May 1465
2 PLAC Westminster
2 SOUR @S1@
3 PAGE Volume 5, page 361
1 ASSO @I130@
2 RELA Elizabeth was Richard's sister and coheir
2 SOUR @S1@
3 PAGE Volume 5, page 361
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:12:00
0 @I87@ INDI
1 NAME Arthur /Plantagenet/
2 SURN Plantagenet
2 GIVN Arthur
1 SEX M
1 NOTE Illegitimate
1 DEAT
2 DATE 3 Mar 1541/1542
2 PLAC Tower of London
2 NOTE without male issue
2 NOTE @N3@
2 SOUR @S1@
3 PAGE Volume 8, page 67
1 _UID B0E9F64C29D7D711BA22AAFF03D37436C877
1 FAMS @F74@
1 FAMS @F75@
1 FAMC @F71@
1 TITL Knight
2 SOUR @S1@
3 PAGE Volume 8, page 64
1 TITL Viscount Lisle
2 DATE 25 Apr 1523
2 NOTE In consequence of his marriage
2 SOUR @S1@
3 PAGE Volume 8, page 64
1 NOTE @N2@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 13:49:50
0 @I88@ INDI
1 NAME James /Stewart/
2 SURN Stewart
2 GIVN James
1 SEX M
1 BIRT
2 DATE 17 Mar 1472/1473
2 SOUR @S2@
3 PAGE Volume 1, page 21
1 DEAT
2 DATE 9 Sep 1513
2 PLAC Flodden
2 SOUR @S2@
3 PAGE Volume 1, page 21
1 TITL James IV of Scotland
2 DATE FROM 11 Jun 1488
2 SOUR @S2@
3 PAGE Volume 1, page 21
1 EVEN
2 TYPE Coronation
2 DATE Jun 1488
2 PLAC Scone
2 SOUR @S2@
3 PAGE Volume 1, page 21
1 _UID E32E9C1D51DAD711BA22444553540000E903
1 FAMS @F145@
1 FAMS @F150@
1 FAMS @F152@
1 FAMS @F156@
1 FAMS @F159@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 18:54:50
0 @I89@ INDI
1 NAME Elizabeth /Grey/
2 SURN Grey
2 GIVN Elizabeth
1 SEX F
1 DEAT
2 DATE ABT 1530
2 SOUR @S1@
3 PAGE Volume 8, page 66
1 BURI
2 NOTE Her body was removed in January 1538, apparently to the parish church of Titchfield, Hampshire
2 SOUR @S1@
3 PAGE Volume 8, pages 66, 67
1 _UID B5E9F64C29D7D711BA22AAFF03D37436CDC7
1 FAMS @F76@
1 FAMS @F74@
1 FAMC @F77@
1 TITL Baroness Lisle in her own right
2 SOUR @S1@
3 PAGE Volume 8, page 63
1 CHAN
2 DATE 28 Aug 2003
3 TIME 13:48:12
0 @I90@ INDI
1 NAME Edward /Grey/
2 SURN Grey
2 GIVN Edward
1 SEX M
1 _UID B8E9F64C29D7D711BA22AAFF03D37436D0F7
1 FAMS @F77@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I91@ INDI
1 NAME Elizabeth /Talbot/
2 SURN Talbot
2 GIVN Elizabeth
1 SEX F
1 _UID BBE9F64C29D7D711BA22AAFF03D37436D327
1 FAMS @F77@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I92@ INDI
1 NAME Edmund /Dudley/
2 SURN Dudley
2 GIVN Edmund
1 SEX M
1 BIRT
2 DATE (Probably about 1470)
2 SOUR @S1@
3 PAGE Volume 14, page 443
1 DEAT
2 DATE 18 Aug 1510
2 PLAC Tower Hill, London
2 CAUS Beheaded
2 SOUR @S1@
3 PAGE Volume 8, page 63
1 _UID BDE9F64C29D7D711BA22AAFF03D37436D547
1 FAMS @F76@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 15:24:06
0 @I93@ INDI
1 NAME Honor /Grenville/
2 SURN Grenville
2 GIVN Honor
1 SEX F
1 _UID C0E9F64C29D7D711BA22AAFF03D37436D877
1 FAMS @F75@
1 FAMS @F78@
1 FAMC @F79@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I94@ INDI
1 NAME John /Basset/
2 SURN Basset
2 GIVN John
1 SEX M
1 DEAT
2 DATE 31 Jan 1528
2 SOUR @S1@
3 PAGE Volume 8, page 67
1 _UID C3E9F64C29D7D711BA22AAFF03D37436DBA7
1 FAMS @F78@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 19:14:42
0 @I95@ INDI
1 NAME Thomas /Grenville/
2 SURN Grenville
2 GIVN Thomas
1 SEX M
1 _UID C6E9F64C29D7D711BA22AAFF03D37436DED7
1 FAMS @F79@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I96@ INDI
1 NAME Isabella /Gilbert/
2 SURN Gilbert
2 GIVN Isabella
1 SEX F
1 _UID C9E9F64C29D7D711BA22AAFF03D37436E107
1 FAMS @F79@
1 FAMC @F80@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I97@ INDI
1 NAME Otes /Gilbert/
2 SURN Gilbert
2 GIVN Otes
1 SEX M
1 _UID CBE9F64C29D7D711BA22AAFF03D37436E327
1 FAMS @F80@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I98@ INDI
1 NAME Cecily /Plantagenet/
2 SURN York
2 GIVN Cecily of
1 SEX F
1 BIRT
2 DATE 20 Mar 1468/1469
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 450
1 DEAT
2 DATE 24 Aug 1507
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 450
1 BURI
2 PLAC Quarr Abbey
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 450
1 _UID CEE9F64C29D7D711BA22AAFF03D37436E657
1 FAMS @F81@
1 FAMS @F82@
1 FAMS @F83@
1 FAMC @F3@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 13:54:46
0 @I99@ INDI
1 NAME John /Welles/
2 SURN Welles
2 GIVN John
1 SEX M
1 DEAT
2 DATE 9 Feb 1498/1499
2 PLAC "Pasmer's Place", St Sithes Lane
2 NOTE without surviving issue
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 449
1 BURI
2 PLAC Westminster Abbey
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 449
1 _UID D0E9F64C29D7D711BA22AAFF03D37436E877
1 FAMS @F82@
1 TITL Viscount Welles
2 DATE BET Nov 1485 AND 8 Feb 1485/6
3 NOTE (created)
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 449
1 CHAN
2 DATE 28 Aug 2003
3 TIME 13:53:23
0 @I100@ INDI
1 NAME Richard /Wydvill/
2 SURN Wydvill
2 GIVN Richard
1 SEX M
1 _UID D4E9F64C29D7D711BA22AAFF03D37436ECB7
1 FAMS @F73@
1 TITL 1st Earl Rivers
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 449
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I101@ INDI
1 NAME Elizabeth /Welles/
2 SURN Welles
2 GIVN Elizabeth
1 SEX F
1 _UID D7E9F64C29D7D711BA22AAFF03D37436EFE7
1 FAMC @F82@
1 SOUR @S1@
2 PAGE Volume 12, part 2, page 449
1 CHAN
2 DATE 28 Aug 2003
3 TIME 13:53:55
0 @I102@ INDI
1 NAME Anne /Welles/
2 SURN Welles
2 GIVN Anne
1 SEX F
1 BURI
2 PLAC Austin Friars, London
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 449
1 _UID D9E9F64C29D7D711BA22AAFF03D37436F107
1 FAMC @F82@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 13:53:48
0 @I103@ INDI
1 NAME Thomas /Kyme/
2 SURN Kyme
2 GIVN Thomas
1 SEX M
1 _UID DBE9F64C29D7D711BA22AAFF03D37436F327
1 FAMS @F83@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I104@ INDI
1 NAME Edward /Plantagenet/
2 SURN Plantagenet
2 GIVN Edward
1 SEX M
1 BIRT
2 DATE Nov 1470
3 NOTE 2 or 3 November
2 SOUR @S1@
3 PAGE Volume 8, page 454
1 _UID DEE9F64C29D7D711BA22AAFF03D37436F657
1 FAMC @F3@
1 TITL Prince of Wales and Earl of Chester
2 DATE FROM 26 Jun 1471
2 SOUR @S1@
3 PAGE Volume 8, page 454
1 TITL Duke of Cornwall
2 DATE FROM 17 Jul 1471
2 SOUR @S1@
3 PAGE Volume 8, page 454
1 TITL Earl of March and Earl of Pembroke
2 DATE FROM 18 Jul 1479
2 SOUR @S1@
3 PAGE Volume 8, page 454
1 TITL King Edward V
2 DATE FROM 9 Apr 1483
2 SOUR @S1@
3 PAGE Volume 8, page 454
1 CHAN
2 DATE 28 Aug 2003
3 TIME 13:55:21
0 @I105@ INDI
1 NAME Richard /Plantagenet/
2 SURN Plantagenet
2 GIVN Richard
1 SEX M
1 BIRT
2 DATE 17 Aug 1473
2 PLAC Shrewsbury
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 910
1 _UID E0E9F64C29D7D711BA22AAFF03D37436F877
1 FAMS @F84@
1 FAMC @F3@
1 TITL Duke of York
2 DATE FROM 28 May 1474
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 911
1 TITL Earl of Nottingham
2 DATE FROM 12 Jun 1476
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 911
1 TITL Earl of Warenne and Duke of Norfolk
2 DATE FROM 7 Feb 1476/7
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 911
1 CHAN
2 DATE 28 Aug 2003
3 TIME 13:56:01
0 @I106@ INDI
1 NAME John /Grey/
2 SURN Grey
2 GIVN John
1 SEX M
1 DEAT
2 DATE 17 Feb 1460/1461
2 SOUR @S1@
3 PAGE Volume 5, page 361
1 _UID E4E9F64C29D7D711BA22AAFF03D37436FCB7
1 FAMS @F72@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:09:52
0 @I107@ INDI
1 NAME Anne /Mowbray/
2 SURN Mowbray
2 GIVN Anne
1 SEX F
1 BIRT
2 DATE 10 Dec 1472
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 913
1 CHR
2 DATE 17 Dec 1472
2 PLAC Framlingham, Suffolk
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 913
1 DEAT
2 DATE BEF 26 Nov 1481
2 NOTE without issue
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 913
1 BURI
2 PLAC Chapel of St Erasmus, Westminster Abbey
2 NOTE Subsequently removed to the Abbey of the Minoresses in the City of London
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 913; volume 14, page 642
1 _UID E7E9F64C29D7D711BA22AAFF03D37436FFE7
1 FAMS @F84@
1 FAMC @F85@
1 TITL Baroness Mowbray and Baroness Segrave
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 913
1 ASSO @I108@
2 RELA Anne was John's only daughter and heir
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 913
1 CHAN
2 DATE 29 Aug 2003
3 TIME 15:25:12
0 @I108@ INDI
1 NAME John /Mowbray/
2 SURN Mowbray
2 GIVN John
1 SEX M
1 _UID EAE9F64C29D7D711BA22AAFF03D374360217
1 FAMS @F85@
1 TITL 4th Duke of Norfolk
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 913
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I109@ INDI
1 NAME Elizabeth /Talbot/
2 SURN Talbot
2 GIVN Elizabeth
1 SEX F
1 _UID EDE9F64C29D7D711BA22AAFF03D374360547
1 FAMS @F85@
1 FAMC @F86@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I110@ INDI
1 NAME John /Talbot/
2 SURN Talbot
2 GIVN John
1 SEX M
1 _UID EFE9F64C29D7D711BA22AAFF03D374360767
1 FAMS @F86@
1 TITL 1st Earl of Shrewsbury
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 913
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I111@ INDI
1 NAME George /Plantagenet/
2 SURN York
2 GIVN George of
1 SEX M
1 BIRT
2 DATE Mar 1476/1477
2 PLAC Windsor
2 SOUR @S1@
3 PAGE Volume 14, page 80
1 DEAT
2 DATE ABT Mar 1479
2 SOUR @S1@
3 PAGE Volume 14, page 80
1 BURI
2 PLAC Windsor
2 SOUR @S1@
3 PAGE Volume 14, page 80
1 _UID F2E9F64C29D7D711BA22AAFF03D374360A97
1 FAMC @F3@
1 TITL Duke of Bedford
2 NOTE Apparently so designated (never created)
2 SOUR @S1@
3 PAGE Volume 2, page 73; volume 14, page 80
1 CHAN
2 DATE 28 Aug 2003
3 TIME 13:58:14
0 @I112@ INDI
1 NAME Elizabeth /Tylney/
2 SURN Tylney
2 GIVN Elizabeth
1 SEX F
1 DEAT
2 DATE 4 Apr 1497
2 SOUR @S1@
3 PAGE Volume 9, page 615
1 _UID F4E9F64C29D7D711BA22AAFF03D374360CB7
1 FAMS @F87@
1 FAMS @F31@
1 FAMC @F88@
1 ASSO @I115@
2 RELA Elizabeth was Frederick's daughter and heir
2 SOUR @S1@
3 PAGE Volume 9, page 614
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:01:50
0 @I113@ INDI
1 NAME Humphrey /Bourchier/
2 SURN Bourchier
2 GIVN Humphrey
1 SEX M
1 _UID F6E9F64C29D7D711BA22AAFF03D374360ED7
1 FAMS @F87@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I114@ INDI
1 NAME John /Bourchier/
2 SURN Bourchier
2 GIVN John
1 SEX M
1 _UID F9E9F64C29D7D711BA22AAFF03D374361107
1 FAMC @F87@
1 TITL Lord Berners
2 SOUR @S1@
3 PAGE Volume 9, page 614
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I115@ INDI
1 NAME Frederick /Tylney/
2 SURN Tylney
2 GIVN Frederick
1 SEX M
1 _UID FBE9F64C29D7D711BA22AAFF03D374361327
1 FAMS @F88@
1 RESI Ashwellthorpe, Norfolk
2 SOUR @S1@
3 PAGE Volume 9, page 614
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I116@ INDI
1 NAME Elizabeth /Cheney/
2 SURN Cheney
2 GIVN Elizabeth
1 SEX F
1 _UID FEE9F64C29D7D711BA22AAFF03D374361657
1 FAMS @F88@
1 FAMC @F89@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I117@ INDI
1 NAME Lawrence /Cheney/
2 SURN Cheney
2 GIVN Lawrence
1 SEX M
1 _UID 00EAF64C29D7D711BA22AAFF03D374361986
1 FAMS @F89@
1 RESI Ditton, Cambridgeshire
2 SOUR @S1@
3 PAGE Volume 9, pages 614, 615
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I118@ INDI
1 NAME Elizabeth /Cokayne/
2 SURN Cokayne
2 GIVN Elizabeth
1 SEX F
1 _UID 03EAF64C29D7D711BA22AAFF03D374361CB6
1 FAMS @F89@
1 FAMC @F90@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I119@ INDI
1 NAME John /Cokayne/
2 SURN Cokayne
2 GIVN John
1 SEX M
1 _UID 05EAF64C29D7D711BA22AAFF03D374361ED6
1 FAMS @F90@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I120@ INDI
1 NAME Agnes /Tylney/
2 SURN Tylney
2 GIVN Agnes
1 SEX F
1 BURI
2 DATE 31 May 1545
2 PLAC Thetford Abbey
2 SOUR @S1@
3 PAGE Volume 9, page 615
1 _UID 0AEAF64C29D7D711BA22AAFF03D374362326
1 FAMS @F34@
1 FAMC @F91@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:03:49
0 @I121@ INDI
1 NAME Hugh /Tylney/
2 SURN Tylney
2 GIVN Hugh
1 SEX M
1 _UID 0DEAF64C29D7D711BA22AAFF03D374362656
1 FAMS @F91@
1 RESI Skirbeck and Boston, Lincolnshire
2 SOUR @S1@
3 PAGE Volume 9, page 615
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I122@ INDI
1 NAME Philip /Tylney/
2 SURN Tylney
2 GIVN Philip
1 SEX M
1 _UID 10EAF64C29D7D711BA22AAFF03D374362986
1 FAMC @F91@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I123@ INDI
1 NAME ... /Tailboys/
2 SURN Tailboys
1 SEX F
1 _UID 12EAF64C29D7D711BA22AAFF03D374362BA6
1 FAMS @F91@
1 FAMC @F92@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I124@ INDI
1 NAME Walter /Tailboys/
2 SURN Tailboys
2 GIVN Walter
1 SEX M
1 _UID 14EAF64C29D7D711BA22AAFF03D374362DC6
1 FAMS @F92@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I125@ INDI
1 NAME Anne /Plantagenet/
2 SURN York
2 GIVN Anne of
1 SEX F
1 BIRT
2 DATE 2 Nov 1475
2 PLAC Westminster
2 SOUR @S1@
3 PAGE Volume 9, page 619
1 DEAT
2 DATE AFT 22 Nov 1511
2 SOUR @S1@
3 PAGE Volume 9, page 619
1 BURI
2 PLAC Thetford
2 NOTE Removed later to Framlingham
2 SOUR @S1@
3 PAGE Volume 9, page 619
1 _UID 19EAF64C29D7D711BA22AAFF03D374363216
1 FAMS @F30@
1 FAMC @F3@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 15:26:00
0 @I126@ INDI
1 NAME Ralph /Scrope/
2 SURN Scrope
2 GIVN Ralph
1 SEX M
1 _UID 1CEAF64C29D7D711BA22AAFF03D374363546
1 FAMS @F81@
1 RESI Upsall
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I127@ INDI
1 NAME ... /Howard/
2 SURN Howard
1 SEX M
1 DEAT
2 DATE 3 Aug 1508
2 SOUR @S1@
3 PAGE Volume 9, page 619, note e
1 BURI
2 PLAC Lambeth
2 SOUR @S1@
3 PAGE Volume 9, page 619, note e
1 _UID 1FEAF64C29D7D711BA22AAFF03D374363876
1 FAMC @F30@
1 TITL Lord Howard
2 SOUR @S1@
3 PAGE Volume 9, page 619
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:06:09
0 @I128@ INDI
1 NAME Eleanor /Percy/
2 SURN Percy
2 GIVN Eleanor
1 SEX F
1 _UID 21EAF64C29D7D711BA22AAFF03D374363A96
1 FAMS @F32@
1 FAMC @F93@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I129@ INDI
1 NAME Henry /Percy/
2 SURN Percy
2 GIVN Henry
1 SEX M
1 _UID 23EAF64C29D7D711BA22AAFF03D374363CB6
1 FAMS @F93@
1 TITL Earl of Norhumberland
2 SOUR @S1@
3 PAGE Volume 4, page 421
3 PAGE Volume 9, page 619
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I130@ INDI
1 NAME Richard /Wydvill/
2 SURN Wydvill
2 GIVN Richard
1 SEX M
1 _UID 26EAF64C29D7D711BA22AAFF03D374363FE6
1 FAMC @F73@
1 TITL 3rd Earl Rivers
2 SOUR @S1@
3 PAGE Volume 5, page 361
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I131@ INDI
1 NAME Jacqueline de /Luxembourg/
2 SURN Luxembourg
2 GIVN Jacqueline de
1 SEX F
1 _UID 28EAF64C29D7D711BA22AAFF03D374364106
1 FAMS @F73@
1 FAMC @F94@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I132@ INDI
1 NAME Peter de /Luxembourg/
2 SURN Luxembourg
2 GIVN Peter de
1 SEX M
1 _UID 2AEAF64C29D7D711BA22AAFF03D374364326
1 FAMS @F94@
1 TITL Count of St Pol, Conversano and Brienne
2 SOUR @S1@
3 PAGE Volume 5, page 361
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I133@ INDI
1 NAME Thomas /Grey/
2 SURN Grey
2 GIVN Thomas
1 SEX M
1 DEAT
2 DATE 30 Aug 1501
2 SOUR @S1@
3 PAGE Volume 5, page 362; volume 14, page 272
1 BURI
2 PLAC Astley, Warwickshire
2 SOUR @S1@
3 PAGE Volume 4, page 419
1 _UID 2DEAF64C29D7D711BA22AAFF03D374364656
1 FAMS @F95@
1 FAMS @F96@
1 FAMC @F72@
1 TITL Lord Ferrers of Groby
2 SOUR @S1@
3 PAGE Volume 5, page 362
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:15:37
0 @I134@ INDI
1 NAME Anne /Holand/
2 SURN Holand
2 GIVN Anne
1 SEX F
1 DEAT
2 DATE (Soon after 26 August 1467)
2 NOTE in her father's lifetime and without issue
2 SOUR @S1@
3 PAGE Volume 4, page 418
1 _UID 2FEAF64C29D7D711BA22AAFF03D374364876
1 FAMS @F95@
1 FAMC @F97@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 15:26:51
0 @I135@ INDI
1 NAME Henry /Holand/
2 SURN Holand
2 GIVN Henry
1 SEX M
1 _UID 32EAF64C29D7D711BA22AAFF03D374364BA6
1 FAMS @F97@
1 TITL Duke of Exeter
2 SOUR @S1@
3 PAGE Volume 4, page 418
1 SOUR @S1@
2 PAGE Volume 4, page 418; volume 14, page 272
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:13:41
0 @I136@ INDI
1 NAME Anne /Plantagenet/
2 SURN Plantagenet
2 GIVN Anne
1 SEX F
1 _UID 35EAF64C29D7D711BA22AAFF03D374364ED6
1 FAMS @F97@
1 FAMC @F98@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I137@ INDI
1 NAME Richard /Plantagenet/
2 SURN Plantagenet
2 GIVN Richard
1 SEX M
1 _UID 37EAF64C29D7D711BA22AAFF03D3743650F6
1 FAMS @F98@
1 TITL Duke of York
2 SOUR @S1@
3 PAGE Volume 4, page 418
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I138@ INDI
1 NAME Cecily /Bonville/
2 SURN Bonville
2 GIVN Cecily
1 SEX F
1 DEAT
2 DATE 12 May 1529
2 SOUR @S1@
3 PAGE Volume 4, page 419; volume 14, page 272
1 BURI
2 PLAC Astley, Warwickshire
2 SOUR @S1@
3 PAGE Volume 4, page 419
1 _UID 3AEAF64C29D7D711BA22AAFF03D374365326
1 FAMS @F96@
1 FAMS @F99@
1 FAMC @F100@
1 TITL Baroness Harington and Baroness Bonville in her own right
2 SOUR @S1@
3 PAGE Volume 4, page 418
1 ASSO @I139@
2 RELA Cecily was William's only daughter and heir
2 SOUR @S1@
3 PAGE Volume 4, page 418
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:16:26
0 @I139@ INDI
1 NAME William /Bonville/
2 SURN Bonville
2 GIVN William
1 SEX M
1 _UID 3DEAF64C29D7D711BA22AAFF03D374365656
1 FAMS @F100@
1 TITL Lord Harington
2 SOUR @S1@
3 PAGE Volume 4, page 418
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I140@ INDI
1 NAME Catherine /Neville/
2 SURN Neville
2 GIVN Catherine
1 SEX F
1 _UID 40EAF64C29D7D711BA22AAFF03D374365986
1 FAMS @F100@
1 CHAN
2 DATE 25 Aug 2003
3 TIME 01:00:00
0 @I141@ INDI
1 NAME Henry /Stafford/
2 SURN Stafford
2 GIVN Henry
1 SEX M
1 DEAT
2 DATE Mar 1523
2 SOUR @S1@
3 PAGE Volume 4, page 419; volume 14, page 272
1 _UID 44EAF64C29D7D711BA22AAFF03D374365DC6
1 FAMS @F99@
1 TITL Earl of Wiltshire
2 SOUR @S1@
3 PAGE Volume 4, page 419
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:16:00
0 @I142@ INDI
1 NAME Henry /Brandon/
2 SURN Brandon
2 GIVN Henry
1 SEX M
1 BIRT
2 DATE 11 Mar 1515/1516
2 PLAC Bath Place, London
2 SOUR @S1@
3 PAGE Volume 7, page 690; volume 12, part 1, pages 460, 461
1 DEAT
2 DATE Mar 1534
3 NOTE 1 or 8 March
2 NOTE unmarried and in his father's lifetime
2 SOUR @S1@
3 PAGE Volume 7, page 690;  volume 12, part 1, pages 460, 461
1 _UID A25AFAACC0D7D711BA22A293179F6D368BBC
1 FAMC @F36@
1 TITL Lord Henry Brandon (more rightly Lord Brandon)
2 SOUR @S1@
3 PAGE Volume 12, part 1, pages 460, 461
1 TITL Earl of Lincoln
2 DATE FROM 18 Jun 1525
2 NOTE in his father's lifetime
2 SOUR @S1@
3 PAGE Volume 7, pages 690
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:19:50
0 @I143@ INDI
1 NAME Frances /Brandon/
2 SURN Brandon
2 GIVN Frances
1 SEX F
1 BIRT
2 DATE 16 Jul 1517
2 PLAC Bishop's Hatfield
2 SOUR @S1@
3 PAGE Volume 4, page 421
1 DEAT
2 DATE 21 Nov 1559
2 PLAC Sheen
2 SOUR @S1@
3 PAGE Volume 4, page 421
1 BURI
2 DATE 5 Dec 1559
2 PLAC Westminster Abbey
2 SOUR @S1@
3 PAGE Volume 4, page 421
1 _UID A45AFAACC0D7D711BA22A293179F6D368DDC
1 FAMS @F101@
1 FAMS @F102@
1 FAMC @F36@
1 ASSO @I39@
2 RELA Frances was Mary's eldest daughter and coheir
2 SOUR @S1@
3 PAGE Volume 4, page 421
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:26:39
0 @I144@ INDI
1 NAME Adrian /Stokes/
2 SURN Stokes
2 GIVN Adrian
1 SEX M
1 DEAT
2 DATE 3 Nov 1585
2 SOUR @S1@
3 PAGE Volume 4, page 421
1 _UID 2AEDCE57CFD7D711BA22ACE9C2156A36B2C6
1 FAMS @F102@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:27:00
0 @I145@ INDI
1 NAME Thomas /Grey/
2 SURN Grey
2 GIVN Thomas
1 SEX M
1 BIRT
2 DATE 22 Jun 1477
2 SOUR @S1@
3 PAGE Volume 4, page 419
1 DEAT
2 DATE 10 Oct 1530
2 SOUR @S1@
3 PAGE Volume 4, page 420
1 _UID A95AFAACC0D7D711BA22A293179F6D36922C
1 FAMS @F103@
1 FAMC @F96@
1 TITL Marquess of Dorset and Lord Ferrers (of Groby)
2 SOUR @S1@
3 PAGE Volume 4, page 419
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:23:56
0 @I146@ INDI
1 NAME Margaret /Wotton/
2 SURN Wotton
2 GIVN Margaret
1 SEX F
1 _UID AB5AFAACC0D7D711BA22A293179F6D36944C
1 FAMS @F104@
1 FAMS @F103@
1 FAMC @F105@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I147@ INDI
1 NAME William /Medley/
2 SURN Medley
2 GIVN William
1 SEX M
1 _UID AE5AFAACC0D7D711BA22A293179F6D36977C
1 FAMS @F104@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I148@ INDI
1 NAME Robert /Wotton/
2 SURN Wotton
2 GIVN Robert
1 SEX M
1 _UID B15AFAACC0D7D711BA22A293179F6D369AAC
1 FAMS @F105@
1 RESI Boughton Malherbe, Kent
2 SOUR @S1@
3 PAGE Volume 4, page 420
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I149@ INDI
1 NAME Anne /Belknap/
2 SURN Belknap
2 GIVN Anne
1 SEX F
1 _UID B45AFAACC0D7D711BA22A293179F6D369DDC
1 FAMS @F105@
1 FAMC @F106@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I150@ INDI
1 NAME Henry /Belknap/
2 SURN Belknap
2 GIVN Henry
1 SEX M
1 _UID B65AFAACC0D7D711BA22A293179F6D369FFC
1 FAMS @F106@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I151@ INDI
1 NAME Henry /Grey/
2 SURN Grey
2 GIVN Henry
1 SEX M
1 BIRT
2 DATE 17 Jan 1517
2 SOUR @S1@
3 PAGE Volume 4, page 420
1 DEAT
2 DATE 23 Feb 1553/1554
2 CAUS Beheaded
2 NOTE without male issue
2 PLAC Tower Hill, London
2 SOUR @S1@
3 PAGE Volume 4, page 421; volume 12, part 1, page 462
1 _UID B95AFAACC0D7D711BA22A293179F6D36A22C
1 FAMS @F107@
1 FAMS @F101@
1 FAMC @F103@
1 TITL Marquess of Dorset
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 462
1 TITL Duke of Suffolk
2 DATE FROM 11 Oct 1551
2 SOUR @S1@
3 PAGE Volume 4, page 421
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:24:14
0 @I152@ INDI
1 NAME Catherine /FitzAlan/
2 SURN FitzAlan
2 GIVN Catherine
1 SEX F
1 _UID BB5AFAACC0D7D711BA22A293179F6D36A44C
1 FAMS @F107@
1 FAMC @F108@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I153@ INDI
1 NAME William /FitzAlan/
2 SURN FitzAlan
2 GIVN William
1 SEX M
1 _UID BE5AFAACC0D7D711BA22A293179F6D36A77C
1 FAMS @F108@
1 TITL Earl of Arundel
2 SOUR @S1@
3 PAGE Volume 4, page 421
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I154@ INDI
1 NAME Anne /Percy/
2 SURN Percy
2 GIVN Anne
1 SEX F
1 _UID C15AFAACC0D7D711BA22A293179F6D36AAAC
1 FAMS @F108@
1 FAMC @F93@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I156@ INDI
1 NAME Eleanor /Brandon/
2 SURN Brandon
2 GIVN Eleanor
1 SEX F
1 DEAT
2 DATE 27 Sep 1547
2 PLAC Brougham Castle
2 NOTE without surviving male issue
2 SOUR @S1@
3 PAGE Volume 3, page 567
1 BURI
2 PLAC Skipton, Yorkshire
2 SOUR @S1@
3 PAGE Volume 3, page 567
1 _UID 2DEDCE57CFD7D711BA22ACE9C2156A36B5F6
1 FAMS @F110@
1 FAMC @F36@
1 ASSO @I40@
2 RELA Eleanor was Charles's youngest daughter and coheir
2 SOUR @S1@
3 PAGE Volume 3, page 567
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:49:55
0 @I157@ INDI
1 NAME Henry /Clifford/
2 SURN Clifford
2 GIVN Henry
1 SEX M
1 DEAT
2 DATE 2 Jan 1569/1570
2 PLAC Brougham Castle
2 SOUR @S1@
3 PAGE Volume 3, page 568
1 BURI
2 PLAC Skipton, Yorkshire
2 SOUR @S1@
3 PAGE Volume 3, page 568
1 _UID 2FEDCE57CFD7D711BA22ACE9C2156A36B716
1 FAMS @F110@
1 FAMS @F111@
1 TITL Earl of Cumberland
2 SOUR @S1@
3 PAGE Volume 3, page 567
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:52:00
0 @I158@ INDI
1 NAME Margaret /Clifford/
2 SURN Clifford
2 GIVN Margaret
1 SEX F
1 DEAT
2 DATE 29 Sep 1596
2 PLAC Cleveland Row, Middlesex
2 SOUR @S1@
3 PAGE Volume 4, page 211
1 BURI
2 DATE 22 Oct 1596
2 PLAC Westminster Abbey
2 SOUR @S1@
3 PAGE Volume 4, page 211
1 _UID 32EDCE57CFD7D711BA22ACE9C2156A36BA46
1 FAMS @F112@
1 FAMC @F110@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:06:26
0 @I159@ INDI
1 NAME Jane /Grey/
2 SURN Grey
2 GIVN Jane
1 SEX F
1 BIRT
2 DATE Oct 1537
2 PLAC Bradgate, Leicestershire
2 SOUR @S5@
3 PAGE Volume 16, page 105
1 DEAT
2 DATE 12 Feb 1553/4
2 PLAC Tower Hill
2 CAUS Executed
2 NOTE without issue
2 SOUR @S4@
3 PAGE 539
1 _UID 90EDCE57CFD7D711BA22ACE9C2156A361826
1 FAMS @F178@
1 FAMC @F101@
1 EVEN
2 TYPE Proclaimed Queen of England
2 DATE 10 Jul 1553
2 PLAC London
2 SOUR @S4@
3 PAGE 526
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I160@ INDI
1 NAME Anne /Dacre/
2 SURN Dacre
2 GIVN Anne
1 SEX F
1 DEAT
2 PLAC Skipton Castle
2 SOUR @S1@
3 PAGE Volume 3, page 568
1 BURI
2 DATE 31 Jul 1581
2 PLAC Skipton, Yorkshire
2 SOUR @S1@
3 PAGE Volume 3, page 568
1 _UID 38EDCE57CFD7D711BA22ACE9C2156A36C0A6
1 FAMS @F111@
1 FAMC @F113@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 19:19:45
0 @I161@ INDI
1 NAME William /Dacre/
2 SURN Dacre
2 GIVN William
1 SEX M
1 _UID 3BEDCE57CFD7D711BA22ACE9C2156A36C3D6
1 FAMS @F113@
1 TITL Lord Dacre (of Gilsland)
2 SOUR @S1@
3 PAGE Volume 3, page 567
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I162@ INDI
1 NAME Elizabeth /Talbot/
2 SURN Talbot
2 GIVN Elizabeth
1 SEX F
1 _UID 3EEDCE57CFD7D711BA22ACE9C2156A36C606
1 FAMS @F113@
1 FAMC @F114@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I163@ INDI
1 NAME George /Talbot/
2 SURN Talbot
2 GIVN George
1 SEX M
1 _UID 40EDCE57CFD7D711BA22ACE9C2156A36C826
1 FAMS @F114@
1 TITL 4th Earl of Shrewsbury
2 SOUR @S1@
3 PAGE Volume 3, page 568
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I164@ INDI
1 NAME Eleanor /Neville/
2 SURN Neville
2 GIVN Eleanor
1 SEX F
1 BURI
2 PLAC St James's Garlickhithe, London
2 SOUR @S1@
3 PAGE Volume 4, page 207
1 _UID 43EDCE57CFD7D711BA22ACE9C2156A36CB56
1 FAMS @F11@
1 FAMC @F115@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:54:40
0 @I165@ INDI
1 NAME Richard /Neville/
2 SURN Neville
2 GIVN Richard
1 SEX M
1 _UID 46EDCE57CFD7D711BA22ACE9C2156A36CE86
1 FAMS @F115@
1 TITL Earl of Salisbury
2 SOUR @S1@
3 PAGE Volume 4, page 418
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I166@ INDI
1 NAME Alice /Montagu/
2 SURN Montagu
2 GIVN Alice
1 SEX F
1 _UID 49EDCE57CFD7D711BA22ACE9C2156A36D1B6
1 FAMS @F115@
1 FAMC @F116@
1 ASSO @I167@
2 RELA Alice was Thomas's daughter and heir
2 SOUR @S1@
3 PAGE Volume 4, page 207
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I167@ INDI
1 NAME Thomas /Montagu/
2 SURN Montagu
2 GIVN Thomas
1 SEX M
1 _UID 4BEDCE57CFD7D711BA22ACE9C2156A36D3D6
1 FAMS @F116@
1 TITL Earl of Salisbury
2 SOUR @S1@
3 PAGE Volume 4, page 207
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I168@ INDI
1 NAME Arthur /Stewart/
2 SURN Stewart
2 GIVN Arthur
1 SEX M
1 BIRT
2 DATE 20 Oct 1509
2 PLAC Holyrood House
2 SOUR @S2@
3 PAGE Volume 1, page 21
1 _UID EA2E9C1D51DAD711BA22444553540000F073
1 FAMC @F145@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:00:20
0 @I169@ INDI
1 NAME George /Stanley/
2 SURN Stanley
2 GIVN George
1 SEX M
1 BIRT
2 DATE ABT 1460
2 SOUR @S1@
3 PAGE Volume 4, page 208
1 DEAT
2 DATE Dec 1503
3 NOTE 4 or 5 December
2 PLAC Derby House, St Paul's Wharf, London
2 NOTE in his father's lifetime
2 SOUR @S1@
3 PAGE Volume 4, page 208
1 BURI
2 PLAC St James's Garlickhithe, London
2 SOUR @S1@
3 PAGE Volume 4, page 208
1 _UID 50EDCE57CFD7D711BA22ACE9C2156A36D826
1 FAMS @F117@
1 FAMC @F11@
1 TITL Lord Strange
2 DATE FROM 15 Nov 1482
2 SOUR @S1@
3 PAGE Volume 4, page 208
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:57:58
0 @I170@ INDI
1 NAME Joan le /Strange/
2 SURN Strange
2 GIVN Joan le
1 SEX F
1 DEAT
2 DATE 20 Mar 1513/1514
2 PLAC Colham Green, Middlesex
2 SOUR @S1@
3 PAGE Volume 4, page 208
1 _UID 52EDCE57CFD7D711BA22ACE9C2156A36DA46
1 FAMS @F117@
1 FAMC @F118@
1 TITL Baroness Strange (of Knokin) and Mohun (of Dunster)
2 DATE FROM 15 Oct 1477
2 SOUR @S1@
3 PAGE Volume 4, page 208
1 ASSO @I171@
2 RELA Joan was John's only daughter and heir
2 SOUR @S1@
3 PAGE Volume 4, page 208
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:58:10
0 @I171@ INDI
1 NAME John le /Strange/
2 SURN Strange
2 GIVN John le
1 SEX M
1 _UID 55EDCE57CFD7D711BA22ACE9C2156A36DD76
1 FAMS @F118@
1 TITL Lord Strange (of Knokin)
2 SOUR @S1@
3 PAGE Volume 4, page 208
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I172@ INDI
1 NAME Jacquette /Wydvill/
2 SURN Wydvill
2 GIVN Jacquette
1 SEX F
1 _UID 58EDCE57CFD7D711BA22ACE9C2156A36E0A6
1 FAMS @F118@
1 FAMC @F73@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I173@ INDI
1 NAME Thomas /Stanley/
2 SURN Stanley
2 GIVN Thomas
1 SEX M
1 BIRT
2 DATE BEF 1485
2 SOUR @S1@
3 PAGE Volume 4, page 208
1 DEAT
2 DATE 23 May 1521
2 PLAC Colham Green, Middlesex
2 SOUR @S1@
3 PAGE Volume 4, page 209
1 BURI
2 PLAC Syon Monastery, Middlesex
2 SOUR @S1@
3 PAGE Volume 4, page 209
1 _UID 5AEDCE57CFD7D711BA22ACE9C2156A36E2C6
1 FAMS @F119@
1 FAMC @F117@
1 TITL Earl of Derby
2 SOUR @S1@
3 PAGE Volume 4, page 208
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:00:03
0 @I174@ INDI
1 NAME Anne /Hastings/
2 SURN Hastings
2 GIVN Anne
1 SEX F
1 DEAT
2 PLAC Colham Green, Middlesex
2 SOUR @S1@
3 PAGE Volume 4, page 209
1 BURI
2 DATE 17 Nov 1550
2 SOUR @S1@
3 PAGE Volume 4, page 209
1 _UID 5CEDCE57CFD7D711BA22ACE9C2156A36E4E6
1 FAMS @F119@
1 FAMC @F120@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:00:30
0 @I175@ INDI
1 NAME Edward /Hastings/
2 SURN Hastings
2 GIVN Edward
1 SEX M
1 _UID 5FEDCE57CFD7D711BA22ACE9C2156A36E716
1 FAMS @F120@
1 TITL Lord Hungerford and Hastings
2 SOUR @S1@
3 PAGE Volume 4, page 209
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I176@ INDI
1 NAME ... /Stewart/
2 SURN Stewart
1 SEX F
1 BIRT
2 DATE 15 Jul 1508
2 SOUR @S2@
3 PAGE Volume 1, page 21
1 _UID E82E9C1D51DAD711BA22444553540000EE53
1 FAMC @F145@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 18:59:59
0 @I177@ INDI
1 NAME Mary /Hungerford/
2 SURN Hungerford
2 GIVN Mary
1 SEX F
1 _UID 64EDCE57CFD7D711BA22ACE9C2156A36EC66
1 FAMS @F120@
1 FAMC @F121@
1 ASSO @I178@
2 RELA Mary was Thomas's daughter and heir
2 SOUR @S1@
3 PAGE Volume 4, page 209
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I178@ INDI
1 NAME Thomas /Hungerford/
2 SURN Hungerford
2 GIVN Thomas
1 SEX M
1 _UID 66EDCE57CFD7D711BA22ACE9C2156A36EE86
1 FAMS @F121@
1 TITL Lord Hungerford
2 SOUR @S1@
3 PAGE Volume 4, page 209
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I179@ INDI
1 NAME Edward /Stanley/
2 SURN Stanley
2 GIVN Edward
1 SEX M
1 BIRT
2 DATE 10 May 1509
2 SOUR @S1@
3 PAGE Volume 4, page 209
1 DEAT
2 DATE 24 Oct 1572
2 PLAC Lathom House
2 SOUR @S1@
3 PAGE Volume 4, page 211
1 BURI
2 DATE 4 Dec 1572
2 PLAC Ormskirk
2 SOUR @S1@
3 PAGE Volume 4, page 211
1 _UID 69EDCE57CFD7D711BA22ACE9C2156A36F1B6
1 FAMS @F122@
1 FAMS @F123@
1 FAMS @F124@
1 FAMC @F119@
1 TITL Earl of Derby
2 SOUR @S1@
3 PAGE Volume 4, page 209
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:03:07
0 @I180@ INDI
1 NAME Dorothy /Howard/
2 SURN Howard
2 GIVN Dorothy
1 SEX F
1 _UID 6BEDCE57CFD7D711BA22ACE9C2156A36F3D6
1 FAMS @F122@
1 FAMC @F34@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I181@ INDI
1 NAME Margaret /Barlow/
2 SURN Barlow
2 GIVN Margaret
1 SEX F
1 DEAT
2 DATE 19 Jan 1558/1559
2 SOUR @S1@
3 PAGE Volume 4, page 210
1 BURI
2 DATE 24 Feb 1558/1559
2 PLAC Ormskirk
2 SOUR @S1@
3 PAGE Volume 4, page 210
1 _UID 70EDCE57CFD7D711BA22ACE9C2156A36F826
1 FAMS @F123@
1 FAMC @F125@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:02:10
0 @I182@ INDI
1 NAME Ellis /Barlow/
2 SURN Barlow
2 GIVN Ellis
1 SEX M
1 _UID 73EDCE57CFD7D711BA22ACE9C2156A36FB56
1 FAMS @F125@
1 RESI Barlow, Lancashire
2 SOUR @S1@
3 PAGE Volume 4, page 210
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I183@ INDI
1 NAME Anne /Reddish/
2 SURN Reddish
2 GIVN Anne
1 SEX F
1 _UID 76EDCE57CFD7D711BA22ACE9C2156A36FE86
1 FAMS @F125@
1 FAMC @F126@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I184@ INDI
1 NAME Otes /Reddish/
2 SURN Reddish
2 GIVN Otes
1 SEX M
1 _UID 78EDCE57CFD7D711BA22ACE9C2156A3600A6
1 FAMS @F126@
1 RESI Reddish, Lancashire
2 SOUR @S1@
3 PAGE Volume 4, page 210
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:04:44
0 @I185@ INDI
1 NAME Mary /Cotton/
2 SURN Cotton
2 GIVN Mary
1 SEX F
1 DEAT
2 DATE 16 Nov 1580
2 NOTE without issue
2 SOUR @S1@
3 PAGE Volume 4, page 211
1 _UID 7BEDCE57CFD7D711BA22ACE9C2156A3603D6
1 FAMS @F124@
1 FAMS @F127@
1 FAMC @F128@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:03:41
0 @I186@ INDI
1 NAME George /Cotton/
2 SURN Cotton
2 GIVN George
1 SEX M
1 _UID 7EEDCE57CFD7D711BA22ACE9C2156A360606
1 FAMS @F128@
1 RESI Combermere, Cheshire
2 SOUR @S1@
3 PAGE Volume 4, page 210
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I187@ INDI
1 NAME Mary /Onley/
2 SURN Onley
2 GIVN Mary
1 SEX F
1 _UID 81EDCE57CFD7D711BA22ACE9C2156A360936
1 FAMS @F128@
1 FAMC @F129@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I188@ INDI
1 NAME John /Onley/
2 SURN Onley
2 GIVN John
1 SEX M
1 _UID 83EDCE57CFD7D711BA22ACE9C2156A360B56
1 FAMS @F129@
1 RESI Catesby, Northamptonshire
2 SOUR @S1@
3 PAGE Volume 4, page 210
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I189@ INDI
1 NAME Henry /Grey/
2 SURN Grey
2 GIVN Henry
1 SEX M
1 DEAT
2 DATE 1 Jan 1614/1615
2 SOUR @S1@
3 PAGE Volume 4, page 211
1 _UID 86EDCE57CFD7D711BA22ACE9C2156A360E86
1 FAMS @F127@
1 TITL 6th Earl of Kent
2 SOUR @S1@
3 PAGE Volume 4, page 211
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:03:35
0 @I190@ INDI
1 NAME Henry /Stanley/
2 SURN Stanley
2 GIVN Henry
1 SEX M
1 BIRT
2 DATE Sep 1531
2 SOUR @S1@
3 PAGE Volume 4, page 211
1 CHR
2 DATE 4 Oct 1531
2 SOUR @S1@
3 PAGE Volume 4, page 211
1 DEAT
2 DATE 25 Sep 1593
2 PLAC Lathom
2 SOUR @S1@
3 PAGE Volume 4, page 211
1 BURI
2 DATE 4 Dec 1593
2 PLAC Ormskirk
2 SOUR @S1@
3 PAGE Volume 4, page 211
1 _UID 89EDCE57CFD7D711BA22ACE9C2156A3611B6
1 FAMS @F112@
1 FAMC @F122@
1 TITL Lord Strange
2 DATE TO 1559
2 SOUR @S1@
3 PAGE Volume 4, page 211
1 TITL Earl of Derby
2 SOUR @S1@
3 PAGE Volume 4, page 211
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:05:39
0 @I191@ INDI
1 NAME Catherine /Grey/
2 SURN Grey
2 GIVN Catherine
1 SEX F
1 BIRT
2 DATE Aug 1540
2 PLAC Probably at Dorset House, Westminster
2 SOUR @S1@
3 PAGE Volume 6, page 506
1 DEAT
2 DATE 27 Jan 1567/1568
2 PLAC Cockfield Hall, Yoxford, Suffolk
2 SOUR @S1@
3 PAGE Volume 6, page 506
1 BURI
2 DATE 21 Feb 1567/1568
2 PLAC Yoxford
2 SOUR @S1@
3 PAGE Volume 6, page 506
1 _UID 92EDCE57CFD7D711BA22ACE9C2156A361A46
1 FAMS @F130@
1 FAMS @F131@
1 FAMC @F101@
1 ASSO @I151@
2 RELA Catherine was Henry's 2nd daughter and coheir
2 SOUR @S1@
3 PAGE Volume 6, page 505
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:20:40
0 @I192@ INDI
1 NAME Mary /Grey/
2 SURN Grey
2 GIVN Mary
1 SEX F
1 DEAT
2 DATE 20 Apr 1578
2 NOTE without issue
2 SOUR @S1@
3 PAGE Volume 4, page 421, note c
1 _UID 94EDCE57CFD7D711BA22ACE9C2156A361C66
1 FAMS @F132@
1 FAMC @F101@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:09:02
0 @I193@ INDI
1 NAME Thomas /Keyes/
2 SURN Keyes
2 GIVN Thomas
3 NOTE (or Henry)
4 SOUR @S1@
5 PAGE Volume 14, page 383
1 SEX M
1 DEAT
2 DATE ABT 3 Sep 1571
2 SOUR @S1@
3 PAGE Volume 4, page 421, note c; volume 14, page 272
1 _UID 96EDCE57CFD7D711BA22ACE9C2156A361E86
1 FAMS @F132@
1 OCCU Serjeant Porter
2 SOUR @S1@
3 PAGE Volume 4, page 421
1 CHAN
2 DATE 28 Aug 2003
3 TIME 14:28:13
0 @I194@ INDI
1 NAME Edward /Seymour/
2 SURN Seymour
2 GIVN Edward
1 SEX M
1 BIRT
2 DATE 12 Oct 1537
2 SOUR @S1@
3 PAGE Volume 6, page 505
1 DEAT
2 DATE 6 Apr 1621
2 PLAC Netley
2 SOUR @S1@
3 PAGE Volume 6, page 506
1 BURI
2 PLAC Salisbury Cathedral
2 SOUR @S1@
3 PAGE Volume 6, page 506
1 _UID 99EDCE57CFD7D711BA22ACE9C2156A3621B6
1 FAMS @F131@
1 FAMS @F133@
1 FAMS @F134@
1 FAMC @F135@
1 TITL Earl of Hertford
2 DATE FROM 1547 TO 1552
2 NOTE (styled)
2 SOUR @S1@
3 PAGE Volume 6, page 505
1 TITL Baron Beauchamp and Earl of Hertford
2 DATE FROM 13 Jan 1558/9
2 SOUR @S1@
3 PAGE Volume 6, page 505
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:23:44
0 @I195@ INDI
1 NAME Edmund /Howard/
2 SURN Howard
2 GIVN Edmund
1 SEX M
1 DEAT
2 DATE 1538
2 SOUR @S1@
3 PAGE Volume 9, Howard pedigree near page 620
1 _UID 9CEDCE57CFD7D711BA22ACE9C2156A3624E6
1 FAMS @F23@
1 FAMC @F31@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:10:53
0 @I196@ INDI
1 NAME Edward /Seymour/
2 SURN Seymour
2 GIVN Edward
1 SEX M
1 BIRT
2 DATE ABT 1500
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 60
1 DEAT
2 DATE 22 Jan 1551/1552
2 CAUS Beheaded
2 NOTE Attainted
2 SOUR @S1@
3 PAGE Volume 6, page 504
1 _UID 9FEDCE57CFD7D711BA22ACE9C2156A362716
1 FAMS @F135@
1 FAMC @F22@
1 TITL Viscount Beauchamp
2 DATE 5 Jun 1536
2 SOUR @S1@
3 PAGE Volume 6, page 504
1 TITL Earl of Hertford
2 DATE 18 Oct 1537
2 SOUR @S1@
3 PAGE Volume 6, page 504
1 TITL Baron Seymour
2 DATE 15 Feb 1546/7
2 SOUR @S1@
3 PAGE Volume 6, page 504
1 TITL Duke of Somerset
2 DATE 16 Feb 1546/7
2 SOUR @S1@
3 PAGE Volume 6, page 504
1 TITL Protector of the Realm
2 DATE FROM 24 Dec 1548 TO 13 Oct 1549
2 SOUR @S1@
3 PAGE Volume 6, page 504
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:28:36
0 @I197@ INDI
1 NAME Anne /Stanhope/
2 SURN Stanhope
2 GIVN Anne
1 SEX F
1 _UID A1EDCE57CFD7D711BA22ACE9C2156A362936
1 FAMS @F135@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I198@ INDI
1 NAME Henry /Herbert/
2 SURN Herbert
2 GIVN Henry
1 SEX M
1 _UID A4EDCE57CFD7D711BA22ACE9C2156A362C66
1 FAMS @F130@
1 TITL Lord Herbert
2 SOUR @S1@
3 PAGE Volume 6, page 505
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I199@ INDI
1 NAME Frances /Howard/
2 SURN Howard
2 GIVN Frances
1 SEX F
1 DEAT
2 DATE 14 May 1598
2 PLAC London
2 NOTE without issue
2 SOUR @S1@
3 PAGE Volume 6, page 506
1 BURI
2 PLAC Westminster Abbey
2 SOUR @S1@
3 PAGE Volume 6, page 506
1 _UID A7EDCE57CFD7D711BA22ACE9C2156A362F96
1 FAMS @F133@
1 FAMC @F136@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:22:28
0 @I200@ INDI
1 NAME William /Howard/
2 SURN Howard
2 GIVN William
1 SEX M
1 DEAT
2 DATE 1573
2 SOUR @S1@
3 PAGE Volume 9, Howard pedigree near page 620
1 _UID AAEDCE57CFD7D711BA22ACE9C2156A3632C6
1 FAMS @F136@
1 FAMC @F34@
1 TITL Baron Howard of Effingham
2 SOUR @S1@
3 PAGE Volume 6, page 506
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:25:29
0 @I201@ INDI
1 NAME Margaret /Gamage/
2 SURN Gamage
2 GIVN Margaret
1 SEX F
1 _UID ADEDCE57CFD7D711BA22ACE9C2156A3635F6
1 FAMS @F136@
1 FAMC @F137@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I202@ INDI
1 NAME Thomas /Gamage/
2 SURN Gamage
2 GIVN Thomas
1 SEX M
1 _UID AFEDCE57CFD7D711BA22ACE9C2156A363716
1 FAMS @F137@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I203@ INDI
1 NAME Frances /Howard/
2 SURN Howard
2 GIVN Frances
1 SEX F
1 DEAT
2 DATE 8 Oct 1639
2 NOTE without issue
2 SOUR @S1@
3 PAGE Volume 6, page 506
1 BURI
2 DATE 12 Oct 1639
2 PLAC Westminster Abbey
2 SOUR @S1@
3 PAGE Volume 6, page 506
1 _UID B7EDCE57CFD7D711BA22ACE9C2156A363F96
1 FAMS @F138@
1 FAMS @F134@
1 FAMS @F139@
1 FAMC @F140@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:24:37
0 @I204@ INDI
1 NAME Henry /Pranell/
2 SURN Pranell
2 GIVN Henry
1 SEX M
1 DEAT
2 DATE 20 Dec 1599
2 SOUR @S1@
3 PAGE Volume 6, page 506
1 _UID BAEDCE57CFD7D711BA22ACE9C2156A3642C6
1 FAMS @F138@
1 OCCU A wealthy wine merchant
2 SOUR @S1@
3 PAGE Volume 6, page 506
1 RESI London
2 SOUR @S1@
3 PAGE Volume 6, page 506
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:23:01
0 @I205@ INDI
1 NAME Thomas /Howard/
2 SURN Howard
2 GIVN Thomas
1 SEX M
1 _UID BDEDCE57CFD7D711BA22ACE9C2156A3645F6
1 FAMS @F140@
1 FAMC @F29@
1 TITL Viscount Howard of Bindon
2 DATE FROM 1559
2 SOUR @S1@
3 PAGE Volume 9, Howard pedigree near page 620
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I206@ INDI
1 NAME Mabel /Burton/
2 SURN Burton
2 GIVN Mabel
1 SEX F
1 _UID BFEDCE57CFD7D711BA22ACE9C2156A364716
1 FAMS @F140@
1 FAMC @F141@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I207@ INDI
1 NAME Nicholas /Burton/
2 SURN Burton
2 GIVN Nicholas
1 SEX M
1 _UID C2EDCE57CFD7D711BA22ACE9C2156A364A46
1 FAMS @F141@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I208@ INDI
1 NAME Ludovic /Stuart/
2 SURN Stuart
2 GIVN Ludovic
1 SEX M
1 DEAT
2 DATE 16 Feb 1623/1624
2 NOTE without legitimate issue
2 SOUR @S1@
3 PAGE Volume 6, page 506
1 BURI
2 PLAC Westminster Abbey
2 SOUR @S1@
3 PAGE Volume 6, page 506
1 _UID C5EDCE57CFD7D711BA22ACE9C2156A364D76
1 FAMS @F139@
1 TITL Duke of Richmond
2 SOUR @S1@
3 PAGE Volume 6, page 506
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:24:23
0 @I209@ INDI
1 NAME Margery /Wentworth/
2 SURN Wentworth
2 GIVN Margery
1 SEX F
1 DEAT
2 DATE Oct 1550
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 60
1 _UID 62E872ADF4D7D711BA224445535400002860
1 FAMS @F22@
1 FAMC @F142@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:28:06
0 @I210@ INDI
1 NAME Henry /Wentworth/
2 SURN Wentworth
2 GIVN Henry
1 SEX M
1 _UID 64E872ADF4D7D711BA224445535400002A80
1 FAMS @F142@
1 RESI Nettlestead, Suffolk
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 60
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I211@ INDI
1 NAME Thomas /Seymour/
2 SURN Seymour
2 GIVN Thomas
1 SEX M
1 BIRT
2 DATE ABT 1508
2 SOUR @S1@
3 PAGE Volume 11, page 637
1 DEAT
2 DATE 20 Mar 1548/1549
2 PLAC Tower Hill
2 CAUS Executed
2 NOTE without male issue
2 SOUR @S1@
3 PAGE Volume 11, page 639
1 BURI
2 PLAC Tower of London
2 SOUR @S1@
3 PAGE Volume 11, page 639
1 _UID 67E872ADF4D7D711BA224445535400002DB0
1 FAMS @F26@
1 FAMC @F22@
1 TITL Baron Seymour of Sudeley
2 DATE FROM 16 Feb 1546/7
2 SOUR @S1@
3 PAGE Volume 11, page 638
1 RESI Sudeley Castle, Gloucestershire
2 SOUR @S1@
3 PAGE Volume 11, page 637
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:32:52
0 @I212@ INDI
1 NAME Thomas /Parr/
2 SURN Parr
2 GIVN Thomas
1 SEX M
1 _UID 6CE872ADF4D7D711BA224445535400003200
1 FAMS @F27@
1 RESI Kendal, Westmorland
2 SOUR @S1@
3 PAGE Volume 11, page 639
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I213@ INDI
1 NAME Maud /Green/
2 SURN Green
2 GIVN Maud
1 SEX F
1 _UID 6FE872ADF4D7D711BA224445535400003530
1 FAMS @F27@
1 FAMC @F143@
1 RESI Green's Norton, Northamptonshire
2 SOUR @S1@
3 PAGE Volume 11, page 639
1 ASSO @I214@
2 RELA Maud was Thomas's daughter and coheir
2 SOUR @S1@
3 PAGE Volume 11, page 639
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I214@ INDI
1 NAME Thomas /Green/
2 SURN Green
2 GIVN Thomas
1 SEX M
1 _UID 71E872ADF4D7D711BA224445535400003750
1 FAMS @F143@
1 CHAN
2 DATE 26 Aug 2003
3 TIME 01:00:00
0 @I215@ INDI
1 NAME Edward /Burgh/
2 SURN Burgh
2 GIVN Edward
1 SEX M
1 DEAT
2 DATE BEF Apr 1533
2 SOUR @S1@
3 PAGE Volume 11, page 639
1 _UID 74E872ADF4D7D711BA224445535400003A80
1 FAMS @F24@
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:31:29
0 @I216@ INDI
1 NAME John /Neville/
2 SURN Neville
2 GIVN John
1 SEX M
1 DEAT
2 DATE 2 Mar 1542/1543
2 SOUR @S1@
3 PAGE Volume 11, page 639
1 _UID 77E872ADF4D7D711BA224445535400003DB0
1 FAMS @F25@
1 TITL 3rd Lord Latimer
2 SOUR @S1@
3 PAGE Volume 11, page 639
1 CHAN
2 DATE 28 Aug 2003
3 TIME 15:31:12
0 @I217@ INDI
1 NAME Gilbert /Gray/
2 SURN Gray
2 GIVN Gilbert
1 SEX M
1 _UID 828837EC5CD9D711BA2284A7D1D71B364A06
1 FAMS @F144@
1 RESI Foulis
2 SOUR @S1@
3 PAGE Volume 8, page 683
1 CHAN
2 DATE 28 Aug 2003
3 TIME 13:44:30
0 @I218@ INDI
1 NAME James /Stewart/
2 SURN Stewart
2 GIVN James
1 SEX M
1 BIRT
2 DATE 10 Apr 1512
2 PLAC Linlithgow
2 SOUR @S2@
3 PAGE Volume 1, page 23
1 DEAT
2 DATE 14 Dec 1542
2 SOUR @S2@
3 PAGE Volume 1, page 23
1 EVEN
2 TYPE Coronation
2 DATE Sep 1513
2 PLAC Stirling
2 SOUR @S2@
3 PAGE Volume 1, page 23
1 _UID EC2E9C1D51DAD711BA22444553540000F293
1 FAMS @F163@
1 FAMS @F165@
1 FAMC @F145@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:32:54
0 @I219@ INDI
1 NAME ... /Stewart/
2 SURN Stewart
1 SEX F
1 BIRT
2 DATE BET 1512 AND 1513
2 SOUR @S2@
3 PAGE Volume 1, page 21
1 _UID EE2E9C1D51DAD711BA22444553540000F4B3
1 FAMC @F145@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 18:58:51
0 @I220@ INDI
1 NAME Alexander /Stewart/
2 SURN Stewart
2 GIVN Alexander
1 SEX M
1 BIRT
2 DATE AFT 9 Sep 1513
2 PLAC Stirling Castle
2 SOUR @S2@
3 PAGE Volume 1, page 21
1 BURI
2 PLAC Cambuskenneth
2 SOUR @S2@
3 PAGE Volume 1, page 21
1 _UID F02E9C1D51DAD711BA22444553540000F6D3
1 FAMC @F145@
1 TITL Duke of Ross
2 SOUR @S2@
3 PAGE Volume 1, page 21
1 CHAN
2 DATE 29 Aug 2003
3 TIME 18:58:01
0 @I221@ INDI
1 NAME Margaret /Douglas/
2 SURN Douglas
2 GIVN Margaret
1 SEX F
1 BIRT
2 DATE Oct 1515
2 PLAC Harbottle
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 DEAT
2 DATE 9 Mar 1577/1578
2 PLAC Hackney
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 _UID F22E9C1D51DAD711BA22444553540000F8F3
1 FAMS @F146@
1 FAMC @F50@
1 SOUR @S2@
2 PAGE Volume 1, page 21
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:08:06
0 @I222@ INDI
1 NAME Matthew /Stuart/
2 SURN Stuart
2 GIVN Matthew
1 SEX M
1 _UID F42E9C1D51DAD711BA22444553540000FA13
1 FAMS @F146@
1 TITL Earl of Lennox
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:07:12
0 @I223@ INDI
1 NAME Henry /Stuart/
2 SURN Stuart
2 GIVN Henry
1 SEX M
1 DEAT
2 DATE 10 Feb 1566/1567
2 PLAC Edinburgh
2 SOUR @S2@
3 PAGE Volume 1, page 26
1 _UID F72E9C1D51DAD711BA22444553540000FD43
1 FAMS @F169@
1 FAMC @F146@
1 TITL Lord Darnley
2 SOUR @S2@
3 PAGE Volume 1, page 26
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:46:39
0 @I224@ INDI
1 NAME Charles /Stuart/
2 SURN Stuart
2 GIVN Charles
1 SEX M
1 _UID F92E9C1D51DAD711BA22444553540000FF63
1 FAMS @F147@
1 FAMC @F146@
1 TITL Earl of Lennox
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:08:52
0 @I225@ INDI
1 NAME Elizabeth /Cavendish/
2 SURN Cavendish
2 GIVN Elizabeth
1 SEX F
1 _UID FB2E9C1D51DAD711BA224445535400000183
1 FAMS @F147@
1 FAMC @F148@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:09:15
0 @I226@ INDI
1 NAME William /Cavendish/
2 SURN Cavendish
2 GIVN William
1 SEX M
1 _UID FE2E9C1D51DAD711BA2244455354000004B3
1 FAMS @F148@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:09:37
0 @I227@ INDI
1 NAME Arabella /Stuart/
2 SURN Stuart
2 GIVN Arabella
1 SEX F
1 DEAT
2 DATE 27 Sep 1615
2 PLAC Tower of London
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 _UID 012F9C1D51DAD711BA2244455354000008F2
1 FAMS @F149@
1 FAMC @F147@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:18:20
0 @I228@ INDI
1 NAME William /Seymour/
2 SURN Seymour
2 GIVN William
1 SEX M
1 _UID 032F9C1D51DAD711BA224445535400000A12
1 FAMS @F149@
1 TITL Marquess of Hertford
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:17:53
0 @I229@ INDI
1 NAME Margaret /Boyd/
2 SURN Boyd
2 GIVN Margaret
1 SEX F
1 _UID 062F9C1D51DAD711BA224445535400000D42
1 FAMS @F150@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:19:14
0 @I230@ INDI
1 NAME Alexander /Stewart/
2 SURN Stewart
2 GIVN Alexander
1 SEX M
1 NOTE Illegitimate
1 BIRT
2 DATE ABT 1493
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 DEAT
2 DATE 1513
2 PLAC Flodden
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 _UID 092F9C1D51DAD711BA224445535400001072
1 FAMC @F150@
1 OCCU Archbishop of St Andrews
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:20:17
0 @I231@ INDI
1 NAME Catherine /Stewart/
2 SURN Stewart
2 GIVN Catherine
1 SEX F
1 NOTE Illegitimate
1 _UID 0B2F9C1D51DAD711BA224445535400001292
1 FAMS @F151@
1 FAMC @F150@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:20:34
0 @I232@ INDI
1 NAME James /Douglas/
2 SURN Douglas
2 GIVN James
1 SEX M
1 _UID 0D2F9C1D51DAD711BA2244455354000014B2
1 FAMS @F151@
1 TITL Earl of Morton
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:20:48
0 @I233@ INDI
1 NAME Janet /Kennedy/
2 SURN Kennedy
2 GIVN Janet
1 SEX F
1 _UID 102F9C1D51DAD711BA2244455354000017E2
1 FAMS @F152@
1 FAMC @F64@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:22:18
0 @I235@ INDI
1 NAME James /Stewart/
2 SURN Stewart
2 GIVN James
1 SEX M
1 NOTE Illegitimate
1 BIRT
2 DATE ABT 1499
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 DEAT
2 DATE 12 Jun 1544
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 _UID 162F9C1D51DAD711BA224445535400001D42
1 FAMS @F154@
1 FAMC @F152@
1 TITL Earl of Moray
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:24:11
0 @I236@ INDI
1 NAME Elizabeth /Campbell/
2 SURN Campbell
2 GIVN Elizabeth
1 SEX F
1 _UID 182F9C1D51DAD711BA224445535400001F62
1 FAMS @F154@
1 FAMC @F155@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:23:28
0 @I237@ INDI
1 NAME Colin /Campbell/
2 SURN Campbell
2 GIVN Colin
1 SEX M
1 _UID 1B2F9C1D51DAD711BA224445535400002292
1 FAMS @F155@
1 TITL Earl of Argyll
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:23:46
0 @I238@ INDI
1 NAME Margaret /Drummond/
2 SURN Drummond
2 GIVN Margaret
1 SEX F
1 _UID 1E2F9C1D51DAD711BA2244455354000025C2
1 FAMS @F156@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:24:33
0 @I239@ INDI
1 NAME Margaret /Stewart/
2 SURN Stewart
2 GIVN Margaret
1 SEX F
1 NOTE Illegitimate
1 BIRT
2 DATE 1497
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 _UID 212F9C1D51DAD711BA2244455354000028F2
1 FAMS @F157@
1 FAMS @F158@
1 FAMC @F156@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:26:34
0 @I240@ INDI
1 NAME John /Gordon/
2 SURN Gordon
2 GIVN John
1 SEX M
1 _UID 232F9C1D51DAD711BA224445535400002A12
1 FAMS @F157@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:26:49
0 @I241@ INDI
1 NAME John /Drummond/
2 SURN Drummond
2 GIVN John
1 SEX M
1 _UID 262F9C1D51DAD711BA224445535400002D42
1 FAMS @F158@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:27:10
0 @I242@ INDI
1 NAME Isabella /Stewart/
2 SURN Stewart
2 GIVN Isabella
1 SEX F
1 _UID 292F9C1D51DAD711BA224445535400003072
1 FAMS @F159@
1 FAMC @F160@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:27:52
0 @I243@ INDI
1 NAME James /Stewart/
2 SURN Stewart
2 GIVN James
1 SEX M
1 _UID 2C2F9C1D51DAD711BA2244455354000033A2
1 FAMS @F160@
1 TITL Earl of Buchan
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:28:12
0 @I244@ INDI
1 NAME Janet /Stewart/
2 SURN Stewart
2 GIVN Janet
1 SEX F
1 NOTE Illegitimate
1 _UID 2F2F9C1D51DAD711BA2244455354000036D2
1 FAMS @F161@
1 FAMS @F162@
1 FAMC @F159@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:28:28
0 @I245@ INDI
1 NAME Malcolm /Fleming/
2 SURN Fleming
2 GIVN Malcolm
1 SEX M
1 _UID 312F9C1D51DAD711BA2244455354000038F2
1 FAMS @F161@
1 TITL Lord Fleming
2 SOUR @S2@
3 PAGE Volume 1, page 22
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:28:48
0 @I246@ INDI
1 NAME Henry of /Valois/
2 SURN Valois
2 GIVN Henry of
1 SEX M
1 _UID 342F9C1D51DAD711BA224445535400003B22
1 FAMS @F162@
1 FAMS @F168@
1 TITL King Henry II of France
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:30:44
0 @I247@ INDI
1 NAME Henry of /Valois/
2 SURN Valois
2 GIVN Henry of
1 SEX M
1 NOTE Illegitimate
1 _UID 392F9C1D51DAD711BA224445535400004072
1 FAMC @F162@
1 SOUR @S2@
2 PAGE Volume 1, page 23
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:32:14
0 @I248@ INDI
1 NAME Madeleine of /Valois/
2 SURN Valois
2 GIVN Madeleine of
1 SEX F
1 BIRT
2 DATE Aug 1520
2 SOUR @S2@
3 PAGE Volume 1, page 23
1 DEAT
2 DATE 7 Jul 1537
2 PLAC Holyrood
2 SOUR @S2@
3 PAGE Volume 1, page 23
1 _UID 3B2F9C1D51DAD711BA224445535400004292
1 FAMS @F163@
1 FAMC @F164@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:39:21
0 @I249@ INDI
1 NAME Francis of /Valois/
2 SURN Valois
2 GIVN Francis of
1 SEX M
1 _UID 3E2F9C1D51DAD711BA2244455354000045C2
1 FAMS @F164@
1 TITL King Francis I of France
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:35:59
0 @I250@ INDI
1 NAME Mary of /Lorraine/
2 SURN Lorraine
2 GIVN Mary of
1 SEX F
1 DEAT
2 DATE 10 Jun 1560
2 PLAC Edinburgh Castle
2 SOUR @S2@
3 PAGE Volume 1, page 23
1 _UID 412F9C1D51DAD711BA2244455354000048F2
1 FAMS @F166@
1 FAMS @F165@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:39:46
0 @I251@ INDI
1 NAME Louis of /Orleans/
2 SURN Orleans
2 GIVN Louis of
1 SEX M
1 _UID 442F9C1D51DAD711BA224445535400004B22
1 FAMS @F166@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:38:47
0 @I252@ INDI
1 NAME James /Stewart/
2 SURN Stewart
2 GIVN James
1 SEX M
1 BIRT
2 DATE 22 May 1540
2 PLAC St Andrews
2 SOUR @S2@
3 PAGE Volume 1, page 23
1 DEAT
2 PLAC Stirling
2 SOUR @S2@
3 PAGE Volume 1, page 23
1 BURI
2 DATE 1541
2 PLAC Holyrood
2 SOUR @S2@
3 PAGE Volume 1, page 23
1 _UID 472F9C1D51DAD711BA224445535400004E52
1 FAMC @F165@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:40:54
0 @I253@ INDI
1 NAME Arthur /Stewart/
2 SURN Stewart
2 GIVN Arthur
1 SEX M
1 BIRT
2 DATE Apr 1541
2 PLAC Falkland
2 SOUR @S2@
3 PAGE Volume 1, page 24
1 BURI
2 PLAC Holyrood
2 SOUR @S2@
3 PAGE Volume 1, page 24
1 _UID 492F9C1D51DAD711BA224445535400005072
1 FAMC @F165@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:41:36
0 @I254@ INDI
1 NAME Mary /Stewart/
2 SURN Stewart
2 GIVN Mary
1 SEX F
1 BIRT
2 DATE Dec 1542
3 NOTE 7 or 8 December
2 PLAC Linlithgow
2 SOUR @S2@
3 PAGE Volume 1, page 25
1 DEAT
2 DATE 8 Feb 1586/1587
2 PLAC Fotheringay Castle, Northamptonshire
2 SOUR @S2@
3 PAGE Volume 1, page 26
1 BURI
2 PLAC Peterborough Cathedral
2 SOUR @S2@
3 PAGE Volume 1, page 26
1 EVEN
2 TYPE Abdication
2 DATE 24 Jul 1567
2 SOUR @S2@
3 PAGE Volume 1, page 26
1 EVEN
2 TYPE Portraits
2 FILE http://www.marileecody.com/maryqosimages.html
2 NOTE Link to Marilee Cody's "Tudor England" website
1 _UID 4B2F9C1D51DAD711BA224445535400005292
1 FAMS @F167@
1 FAMS @F169@
1 FAMS @F170@
1 FAMC @F165@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:49:20
0 @I255@ INDI
1 NAME Francis of /Valois/
2 SURN Valois
2 GIVN Francis of
1 SEX M
1 DEAT
2 DATE 5 Dec 1560
2 SOUR @S2@
3 PAGE Volume 1, page 26
1 _UID 4D2F9C1D51DAD711BA2244455354000054B2
1 FAMS @F167@
1 FAMC @F168@
1 TITL King Francis II of France
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:45:07
0 @I256@ INDI
1 NAME Catherine de /Medicis/
2 SURN Medicis
2 GIVN Catherine de
1 SEX F
1 EVEN
2 TYPE Portrait
2 FILE http://www.marileecody.com/medici.jpg
2 NOTE Link to Marilee Cody's "Tudor England" website
1 _UID 512F9C1D51DAD711BA2244455354000058F2
1 FAMS @F168@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:44:14
0 @I257@ INDI
1 NAME James /Stuart/
2 SURN Stuart
2 GIVN James
1 SEX M
1 BIRT
2 DATE 19 Jun 1566
2 PLAC Edinburgh Castle
2 SOUR @S2@
3 PAGE Volume 1, page 26
1 DEAT
2 DATE 27 Mar 1625
2 SOUR @S2@
3 PAGE Volume 1, page 27
1 _UID 542F9C1D51DAD711BA224445535400005B22
1 FAMS @F171@
1 FAMC @F169@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:50:24
0 @I258@ INDI
1 NAME James /Hepburn/
2 SURN Hepburn
2 GIVN James
1 SEX M
1 TITL Earl of Bothwell
2 SOUR @S2@
3 PAGE Volume 1, page 26
1 _UID 582F9C1D51DAD711BA224445535400005F62
1 FAMS @F170@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:47:31
0 @I259@ INDI
1 NAME Anne of /Oldenburg/
2 SURN Oldenburg
2 GIVN Anne of
1 SEX F
1 DEAT
2 DATE 2 Mar 1618/1619
2 SOUR @S2@
3 PAGE Volume 1, page 27
1 _UID 5B2F9C1D51DAD711BA224445535400006292
1 FAMS @F171@
1 CHAN
2 DATE 29 Aug 2003
3 TIME 19:51:29
0 @I260@ INDI
1 NAME Mary /Boleyn/
2 SURN Boleyn
2 GIVN Mary
1 SEX F
1 DEAT
2 DATE 19 Jul 1543
2 SOUR @S3@
3 PAGE 346
1 _UID 429304CACCDAD711BA22B8E68CB2433561B1
1 FAMS @F172@
1 FAMS @F174@
1 FAMS @F173@
1 FAMC @F21@
1 CHAN
2 DATE 30 Aug 2003
3 TIME 09:36:56
0 @I261@ INDI
1 NAME William /Carey/
2 SURN Carey
2 GIVN William
1 SEX M
1 DEAT
2 DATE 22 Jun 1528
2 SOUR @S3@
3 PAGE 346
1 _UID 449304CACCDAD711BA22B8E68CB2433563D1
1 FAMS @F172@
1 CHAN
2 DATE 30 Aug 2003
3 TIME 09:35:17
0 @I262@ INDI
1 NAME William /Stafford/
2 SURN Stafford
2 GIVN William
1 SEX M
1 DEAT
2 DATE 5 May 1556
2 PLAC Geneva
2 SOUR @S3@
3 PAGE 346
1 _UID 479304CACCDAD711BA22B8E68CB243356601
1 FAMS @F173@
1 CHAN
2 DATE 30 Aug 2003
3 TIME 09:36:18
0 @I263@ INDI
1 NAME Henry /Carey/
2 SURN Carey
2 GIVN Henry
1 SEX M
1 NOTE Parentage doubtful
1 BIRT
2 DATE 4 Mar 1525/1526
2 SOUR @S3@
3 PAGE 346
1 DEAT
2 DATE 23 Jul 1596
2 PLAC Somerset House, London
2 SOUR @S3@
3 PAGE 350
1 BURI
2 DATE 12 Aug 1596
2 PLAC Westminster Abbey
2 SOUR @S3@
3 PAGE 350
1 _UID 4D9304CACCDAD711BA22B8E68CB243356C61
1 FAMS @F176@
1 FAMC @F174@
1 CHAN
2 DATE 30 Aug 2003
3 TIME 09:56:34
0 @I264@ INDI
1 NAME Catherine /Carey/
2 SURN Carey
2 GIVN Catherine
1 SEX F
1 NOTE Parentage doubtful
1 BIRT
2 DATE ABT 1524
2 SOUR @S3@
3 PAGE 347
1 _UID 4F9304CACCDAD711BA22B8E68CB243356E81
1 FAMS @F175@
1 FAMC @F174@
1 CHAN
2 DATE 30 Aug 2003
3 TIME 09:45:15
0 @I265@ INDI
1 NAME Elizabeth /Tudor/
2 SURN Tudor
2 GIVN Elizabeth
1 SEX F
1 BIRT
2 DATE 7 Sep 1533
2 PLAC Greenwich
2 SOUR @S5@
3 PAGE Volume 17, page 203
1 DEAT
2 DATE 24 Mar 1603
2 SOUR @S5@
3 PAGE Volume 17, page 229
1 BURI
2 DATE 28 Apr 1603
2 PLAC Westminster Abbey
2 SOUR @S5@
3 PAGE Volume 17, page 229
1 TITL Queen Elizabeth I
2 DATE FROM 17 Nov 1558
2 SOUR @S5@
3 PAGE Volume 17, page 208
1 EVEN
2 TYPE Portraits
2 FILE http://www.marileecody.com/eliz1-images.html
2 NOTE Link to Marilee Cody's "Tudor England" website
1 _UID 519304CACCDAD711BA22B8E68CB2433570A1
1 FAMC @F13@
1 CHAN
2 DATE 30 Aug 2003
3 TIME 09:48:16
0 @I266@ INDI
1 NAME Mary /Tudor/
2 SURN Tudor
2 GIVN Mary
1 SEX F
1 BIRT
2 DATE 18 Feb 1515/6
2 PLAC Greenwich Palace
2 SOUR @S5@
3 PAGE Volume 36, page 333
1 DEAT
2 DATE 17 Nov 1558
2 SOUR @S4@
3 PAGE 560
1 _UID 539304CACCDAD711BA22B8E68CB2433572C1
1 FAMS @F177@
1 FAMC @F12@
1 TITL Queen Mary I
2 NOTE (proclaimed in London 19 July 1553)
2 SOUR @S4@
3 PAGE Pages 528, 529
1 EVEN
2 TYPE Portraits
2 FILE http://www.marileecody.com/mary1images.html
2 NOTE Link to Marilee Cody's "Tudor England" website
1 CHAN
2 DATE 30 Aug 2003
3 TIME 09:48:36
0 @I267@ INDI
1 NAME Francis /Knollys/
2 SURN Knollys
2 GIVN Francis
1 SEX M
1 DEAT
2 DATE 19 Jul 1596
2 SOUR @S3@
3 PAGE 348
1 _UID 559304CACCDAD711BA22B8E68CB2433574E1
1 FAMS @F175@
1 CHAN
2 DATE 30 Aug 2003
3 TIME 09:52:34
0 @I268@ INDI
1 NAME Anne /Morgan/
2 SURN Morgan
2 GIVN Anne
1 SEX F
1 _UID 589304CACCDAD711BA22B8E68CB243357711
1 FAMS @F176@
1 CHAN
2 DATE 30 Aug 2003
3 TIME 09:56:50
0 @I269@ INDI
1 NAME Philip of /Hapsburg/
2 SURN Hapsburg
2 GIVN Philip of
1 SEX M
1 _UID 5B9304CACCDAD711BA22B8E68CB243357A41
1 FAMS @F177@
1 TITL King Philip II of Spain
1 CHAN
2 DATE 30 Aug 2003
3 TIME 10:33:07
0 @I270@ INDI
1 NAME Guilford /Dudley/
2 GIVN Guilford
1 SEX M
1 FAMS @F178@
1 DEAT
2 DATE 12 Feb 1553/4
2 PLAC Tower Hill
2 CAUS Executed
2 SOUR @S4@
3 PAGE 539
0 @I271@ INDI
1 NAME Margaret /Kyme/
2 SURN Kyme
2 GIVN Margaret
1 SEX F
1 FAMC @F83@
1 NOTE @N4@
0 @F1@ FAM
1 MARR
2 DATE 18 Jan 1486
2 SOUR @S4@
3 PAGE 65
1 _UID A7220CEE05D7D711BA228E18B8357A36A6D7
1 HUSB @I1@
1 WIFE @I2@
1 CHIL @I28@
1 CHIL @I66@
1 CHIL @I14@
1 CHIL @I39@
1 CHIL @I27@
0 @F2@ FAM
1 _UID 2400C4FC09D7D711BA22444553540000B863
1 HUSB @I3@
1 WIFE @I4@
1 CHIL @I1@
1 MARR
2 DATE 1455
2 SOUR @S1@
3 PAGE Volume 10, page 826
0 @F3@ FAM
1 _UID A8E9F64C29D7D711BA22AAFF03D37436C0F7
1 HUSB @I85@
1 WIFE @I86@
1 CHIL @I2@
1 CHIL @I98@
1 CHIL @I104@
1 CHIL @I105@
1 CHIL @I125@
1 CHIL @I111@
1 MARR
2 DATE 1 May 1464
2 PLAC Grafton Regis, Northamptonshire
2 NOTE (secretly)
2 SOUR @S1@
3 PAGE Volume 5, page 361
0 @F4@ FAM
1 _UID 2B00C4FC09D7D711BA22444553540000BFD3
1 HUSB @I5@
1 WIFE @I4@
1 SOUR @S1@
2 PAGE Volume 10, page 826
0 @F5@ FAM
1 _UID 3C00C4FC09D7D711BA22444553540000D0E3
1 HUSB @I11@
1 WIFE @I4@
1 MARR
2 DATE BEF 1464
2 SOUR @S1@
3 PAGE Volume 10, page 827
0 @F6@ FAM
1 _UID 4200C4FC09D7D711BA22444553540000D643
1 HUSB @I13@
1 WIFE @I4@
1 MARR
2 DATE BEF Oct 1473
2 SOUR @S1@
3 PAGE Volume 10, page 827
0 @F7@ FAM
1 _UID 2F00C4FC09D7D711BA22444553540000C313
1 HUSB @I6@
1 WIFE @I7@
1 CHIL @I4@
1 SOUR @S1@
2 PAGE Volume 10, page 826
0 @F8@ FAM
1 _UID 3400C4FC09D7D711BA22444553540000C863
1 HUSB @I8@
1 WIFE @I7@
1 SOUR @S1@
2 PAGE Volume 10, page 826
0 @F9@ FAM
1 _UID 3700C4FC09D7D711BA22444553540000CB93
1 HUSB @I9@
1 CHIL @I7@
0 @F10@ FAM
1 _UID 3F00C4FC09D7D711BA22444553540000D313
1 HUSB @I12@
1 CHIL @I11@
0 @F11@ FAM
1 _UID 44EDCE57CFD7D711BA22ACE9C2156A36CC66
1 HUSB @I13@
1 WIFE @I164@
1 CHIL @I169@
1 MARR
2 DATE AFT 10 May 1457
2 SOUR @S1@
3 PAGE Volume 4, page 207
0 @F12@ FAM
1 _UID 4700C4FC09D7D711BA22444553540000DB93
1 HUSB @I14@
1 WIFE @I15@
1 CHIL @I32@
1 CHIL @I33@
1 CHIL @I266@
1 MARR
2 DATE 11 Jun 1509
2 PLAC Greyfriars, Greenwich
2 NOTE secretly
2 NOTE a papal dispensation was given
2 SOUR @S1@
3 PAGE Volume 3, page 442
1 EVEN
2 TYPE Marriage pronounced null
2 DATE 23 May 1533
2 SOUR @S1@
3 PAGE Volume 3, page 442
0 @F13@ FAM
1 _UID 4A00C4FC09D7D711BA22444553540000DEC3
1 HUSB @I14@
1 WIFE @I16@
1 CHIL @I265@
1 MARR
2 DATE ABT 25 Jan 1532/1533
2 PLAC Whitehall
2 SOUR @S1@
3 PAGE Volume 10, page 404
0 @F14@ FAM
1 MARR
2 DATE 30 May 1536
2 NOTE (privately)
2 SOUR @S4@
3 PAGE 380
1 _UID 5000C4FC09D7D711BA22444553540000E423
1 HUSB @I14@
1 WIFE @I18@
1 CHIL @I34@
0 @F15@ FAM
1 MARR
2 DATE 6 Jan 1539/40
2 SOUR @S4@
3 PAGE 404
1 EVEN
2 TYPE Marriage declared null and void
2 DATE 9 Jul 1540
2 SOUR @S5@
3 PAGE Volume 1, page 430
1 _UID 4D00C4FC09D7D711BA22444553540000E1F3
1 HUSB @I14@
1 WIFE @I17@
0 @F16@ FAM
1 MARR
2 DATE 28 Jul 1540
2 SOUR @S4@
3 PAGE 417
1 _UID 5300C4FC09D7D711BA22444553540000E753
1 HUSB @I14@
1 WIFE @I19@
0 @F17@ FAM
1 MARR
2 DATE 12 Jul 1543
2 SOUR @S4@
3 PAGE 419
1 _UID 5600C4FC09D7D711BA22444553540000EA83
1 HUSB @I14@
1 WIFE @I20@
0 @F18@ FAM
1 NOTE Not married
1 _UID 5900C4FC09D7D711BA22444553540000EDB3
1 HUSB @I14@
1 WIFE @I21@
1 CHIL @I22@
1 SOUR @S1@
2 PAGE Volume 10, page 829
0 @F19@ FAM
1 _UID 6B00C4FC09D7D711BA22444553540000FFD3
1 HUSB @I28@
1 WIFE @I15@
1 MARR
2 DATE 14 Nov 1501
2 PLAC St Paul's Cathedral, London
2 SOUR @S1@
3 PAGE Volume 3, page 442
0 @F20@ FAM
1 _UID 6E00C4FC09D7D711BA224445535400000203
1 HUSB @I29@
1 WIFE @I30@
1 CHIL @I15@
1 SOUR @S1@
2 PAGE Volume 3, page 442
0 @F21@ FAM
1 _UID 7F00C4FC09D7D711BA224445535400001313
1 HUSB @I36@
1 WIFE @I37@
1 CHIL @I16@
1 CHIL @I260@
1 SOUR @S1@
2 PAGE Volume 9, Howard pedigree near page 620
0 @F22@ FAM
1 _UID 7C00C4FC09D7D711BA2244455354000010E3
1 HUSB @I35@
1 WIFE @I209@
1 CHIL @I18@
1 CHIL @I196@
1 CHIL @I211@
1 SOUR @S1@
2 PAGE Volume 12, part 1, page 60
0 @F23@ FAM
1 _UID 9DEDCE57CFD7D711BA22ACE9C2156A3625F6
1 HUSB @I195@
1 CHIL @I19@
0 @F24@ FAM
1 _UID 75E872ADF4D7D711BA224445535400003B90
1 HUSB @I215@
1 WIFE @I20@
1 SOUR @S1@
2 PAGE Volume 11, page 639
0 @F25@ FAM
1 _UID 78E872ADF4D7D711BA224445535400003EC0
1 HUSB @I216@
1 WIFE @I20@
1 SOUR @S1@
2 PAGE Volume 11, page 639
0 @F26@ FAM
1 MARR
2 DATE AFT 28 Jan 1546/7
3 NOTE Some months after the death of Henry VIII, probably before the end of May 1547
2 NOTE (secretly)
2 SOUR @S1@
3 PAGE Volume 11, page 638
1 _UID 6AE872ADF4D7D711BA2244455354000030E0
1 HUSB @I211@
1 WIFE @I20@
1 SOUR @S1@
2 PAGE Volume 11, pages 638, 639
0 @F27@ FAM
1 _UID 6DE872ADF4D7D711BA224445535400003310
1 HUSB @I212@
1 WIFE @I213@
1 CHIL @I20@
1 SOUR @S1@
2 PAGE Volume 11, page 639
0 @F28@ FAM
1 _UID 5E00C4FC09D7D711BA22444553540000F203
1 HUSB @I22@
1 WIFE @I23@
1 EVEN
2 TYPE Marriage dispensation
2 DATE 28 Nov 1533
2 SOUR @S1@
3 PAGE Volume 10, page 830
0 @F29@ FAM
1 _UID 6100C4FC09D7D711BA22444553540000F533
1 HUSB @I24@
1 WIFE @I25@
1 CHIL @I23@
1 CHIL @I205@
1 MARR
2 DATE BEF 8 Jan 1512/1513
2 SOUR @S1@
3 PAGE Volume 9, page 619
0 @F30@ FAM
1 _UID 1AEAF64C29D7D711BA22AAFF03D374363326
1 HUSB @I24@
1 WIFE @I125@
1 CHIL @I127@
1 MARR
2 DATE 4 Feb 1494/1495
2 PLAC Greenwich
2 SOUR @S1@
3 PAGE Volume 9, page 619
1 NOTE Of her four children only one lived to be baptised
2 SOUR @S1@
3 PAGE Volume 9, page 619, note e
0 @F31@ FAM
1 _UID 8400C4FC09D7D711BA224445535400001863
1 HUSB @I38@
1 WIFE @I112@
1 CHIL @I37@
1 CHIL @I24@
1 CHIL @I195@
1 MARR
2 DATE 30 Apr 1472
2 SOUR @S1@
3 PAGE Volume 9, page 614
0 @F32@ FAM
1 _UID 6600C4FC09D7D711BA22444553540000FA83
1 HUSB @I26@
1 WIFE @I128@
1 CHIL @I25@
1 SOUR @S1@
2 PAGE Volume 9, page 619
0 @F33@ FAM
1 _UID 7300C4FC09D7D711BA224445535400000753
1 HUSB @I31@
1 CHIL @I30@
0 @F34@ FAM
1 _UID 0BEAF64C29D7D711BA22AAFF03D374362436
1 HUSB @I38@
1 WIFE @I120@
1 CHIL @I180@
1 CHIL @I200@
1 SOUR @S1@
2 PAGE Volume 9, page 615
0 @F35@ FAM
1 _UID A800C4FC09D7D711BA224445535400003CA3
1 HUSB @I51@
1 WIFE @I39@
1 SOUR @S1@
2 PAGE Volume 12, part 1, page 459
0 @F36@ FAM
1 _UID 8900C4FC09D7D711BA224445535400001DB3
1 HUSB @I40@
1 WIFE @I39@
1 CHIL @I142@
1 CHIL @I143@
1 CHIL @I156@
1 MARR
2 DATE AFT 4 Feb 1514/5
2 PLAC Probably the Hotel Cluny, Paris
3 NOTE Privately and without the Royal consent
2 DATE 13 May 1515
2 PLAC Greenwich
3 NOTE Publicly
2 SOUR @S1@
3 PAGE Volume 12, part 1, pages 456, 459
0 @F37@ FAM
1 _UID 9400C4FC09D7D711BA224445535400002863
1 HUSB @I40@
1 WIFE @I44@
1 MARR
2 DATE (Perhaps after 25 September 1505)
3 NOTE (first marriage)
2 DATE ABT 1508
3 NOTE (remarriage after second marriage declared void)
2 SOUR @S1@
3 PAGE Volume 12, part 1, pages 458, 459
0 @F38@ FAM
1 _UID 9700C4FC09D7D711BA224445535400002B93
1 HUSB @I40@
1 WIFE @I45@
1 MARR
2 DATE BEF 7 Feb 1506/1507
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 458
1 EVEN
2 TYPE Marriage declared void by Archdeaconry Court of London
2 DATE ABT 1507
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 458
1 EVEN
2 TYPE Marriage declared void by Papal Bull
2 DATE 12 May 1528
2 PLAC Orvieto
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 458
0 @F39@ FAM
1 _UID AB00C4FC09D7D711BA224445535400003FD3
1 HUSB @I40@
1 WIFE @I52@
1 MARR
2 DATE (Perhaps 7 September 1533)
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 460
0 @F40@ FAM
1 _UID 8C00C4FC09D7D711BA2244455354000020E3
1 HUSB @I41@
1 WIFE @I42@
1 CHIL @I40@
1 SOUR @S1@
2 PAGE Volume 12, part 1, page 454
0 @F41@ FAM
1 _UID 9100C4FC09D7D711BA224445535400002533
1 HUSB @I43@
1 CHIL @I42@
0 @F42@ FAM
1 _UID A500C4FC09D7D711BA224445535400003973
1 HUSB @I50@
1 CHIL @I44@
0 @F43@ FAM
1 _UID A200C4FC09D7D711BA224445535400003643
1 HUSB @I49@
1 WIFE @I45@
1 SOUR @S1@
2 PAGE Volume 12, part 1, page 458
0 @F44@ FAM
1 _UID 9A00C4FC09D7D711BA224445535400002EC3
1 HUSB @I46@
1 WIFE @I47@
1 CHIL @I45@
1 SOUR @S1@
2 PAGE Volume 12, part 1, page 458
0 @F45@ FAM
1 _UID 9F00C4FC09D7D711BA224445535400003313
1 HUSB @I48@
1 CHIL @I47@
0 @F46@ FAM
1 _UID B600C4FC09D7D711BA224445535400004A83
1 HUSB @I56@
1 WIFE @I52@
1 MARR
2 DATE (Early 1553)
2 SOUR @S1@
3 PAGE Volume 12, part 1, page 460
0 @F47@ FAM
1 _UID AE00C4FC09D7D711BA224445535400004203
1 HUSB @I53@
1 WIFE @I54@
1 CHIL @I52@
1 SOUR @S1@
2 PAGE Volume 12, part 1, page 460
0 @F49@ FAM
1 _UID C600C4FC09D7D711BA224445535400005A83
1 HUSB @I57@
1 WIFE @I62@
1 MARC 
2 DATE 26 Jun 1509
2 SOUR @S1@
3 PAGE Volume 1, page 157
0 @F50@ FAM
1 _UID D100C4FC09D7D711BA224445535400006533
1 HUSB @I57@
1 WIFE @I66@
1 CHIL @I221@
1 MARR
2 DATE 6 Aug 1514
2 PLAC Kinnoull Chapel
2 SOUR @S1@
3 PAGE Volume 1, page 157
2 SOUR @S2@
3 PAGE Volume 1, page 21
0 @F51@ FAM
1 _UID D400C4FC09D7D711BA224445535400006863
1 HUSB @I57@
1 WIFE @I67@
1 MARR
2 DATE 9 Apr 1543
2 SOUR @S1@
3 PAGE Volume 1, page 158
0 @F52@ FAM
1 _UID BB00C4FC09D7D711BA224445535400004FD3
1 HUSB @I58@
1 WIFE @I59@
1 CHIL @I57@
1 SOUR @S1@
2 PAGE Volume 1, page 157
0 @F53@ FAM
1 _UID C300C4FC09D7D711BA224445535400005753
1 HUSB @I61@
1 WIFE @I59@
1 SOUR @S1@
2 PAGE Volume 1, page 157
0 @F54@ FAM
1 _UID C000C4FC09D7D711BA224445535400005423
1 HUSB @I60@
1 CHIL @I59@
0 @F55@ FAM
1 _UID C900C4FC09D7D711BA224445535400005DB3
1 HUSB @I63@
1 WIFE @I64@
1 CHIL @I62@
1 SOUR @S1@
2 PAGE Volume 1, page 157
0 @F56@ FAM
1 _UID CE00C4FC09D7D711BA224445535400006203
1 HUSB @I65@
1 CHIL @I64@
0 @F57@ FAM
1 _UID 83E9F64C29D7D711BA22AAFF03D374369BA7
1 HUSB @I72@
1 WIFE @I66@
1 MARR
2 DATE Mar 1527/1528
2 SOUR @S1@
3 PAGE Volume 8, page 683
0 @F58@ FAM
1 _UID DF00C4FC09D7D711BA224445535400007313
1 HUSB @I71@
1 WIFE @I67@
1 MARR
2 DATE BEF Sep 1560
2 SOUR @S1@
3 PAGE Volume 1, page 158
0 @F59@ FAM
1 _UID D700C4FC09D7D711BA224445535400006B93
1 HUSB @I68@
1 WIFE @I69@
1 CHIL @I67@
1 SOUR @S1@
2 PAGE Volume 1, page 158
0 @F60@ FAM
1 _UID DC00C4FC09D7D711BA2244455354000070E3
1 HUSB @I70@
1 CHIL @I69@
0 @F61@ FAM
1 _UID 8EE9F64C29D7D711BA22AAFF03D37436A657
1 HUSB @I72@
1 WIFE @I76@
1 SOUR @S1@
2 PAGE Volume 8, page 683
1 NOTE @N1@
0 @F62@ FAM
1 _UID 91E9F64C29D7D711BA22AAFF03D37436A987
1 HUSB @I72@
1 WIFE @I77@
1 MARR
2 DATE BEF 4 Nov 1544
2 SOUR @S1@
3 PAGE Volume 8, page 683
0 @F63@ FAM
1 _UID 86E9F64C29D7D711BA22AAFF03D374369ED7
1 HUSB @I73@
1 WIFE @I74@
1 CHIL @I72@
1 SOUR @S1@
2 PAGE Volume 8, page 682
0 @F64@ FAM
1 SOUR @S2@
2 PAGE Volume 1, page 22
1 _UID 8BE9F64C29D7D711BA22AAFF03D37436A327
1 HUSB @I75@
1 CHIL @I74@
1 CHIL @I233@
0 @F65@ FAM
1 _UID 97E9F64C29D7D711BA22AAFF03D37436AFE7
1 HUSB @I79@
1 WIFE @I77@
1 SOUR @S1@
2 PAGE Volume 8, page 683
0 @F66@ FAM
1 _UID 94E9F64C29D7D711BA22AAFF03D37436ACB7
1 HUSB @I78@
1 WIFE @I77@
1 SOUR @S1@
2 PAGE Volume 8, page 683
0 @F67@ FAM
1 _UID A2E9F64C29D7D711BA22AAFF03D37436BA97
1 HUSB @I83@
1 WIFE @I77@
1 SOUR @S1@
2 PAGE Volume 8, page 683
0 @F68@ FAM
1 _UID A5E9F64C29D7D711BA22AAFF03D37436BDC7
1 HUSB @I84@
1 WIFE @I77@
1 SOUR @S1@
2 PAGE Volume 8, page 683
0 @F69@ FAM
1 _UID 9AE9F64C29D7D711BA22AAFF03D37436B217
1 HUSB @I80@
1 WIFE @I81@
1 CHIL @I77@
1 SOUR @S1@
2 PAGE Volume 8, page 683
0 @F70@ FAM
1 _UID 9FE9F64C29D7D711BA22AAFF03D37436B767
1 HUSB @I82@
1 CHIL @I81@
0 @F71@ FAM
1 NOTE Not married
1 _UID B1E9F64C29D7D711BA22AAFF03D37436C987
1 HUSB @I85@
1 CHIL @I87@
1 SOUR @S1@
2 PAGE Volume 8, page 63
1 NOTE @N2@
0 @F72@ FAM
1 _UID E5E9F64C29D7D711BA22AAFF03D37436FDC7
1 HUSB @I106@
1 WIFE @I86@
1 CHIL @I133@
1 MARR
2 DATE ABT 1455
2 SOUR @S1@
3 PAGE Volume 5, page 361; volume 14, page 321
0 @F73@ FAM
1 _UID D5E9F64C29D7D711BA22AAFF03D37436EDC7
1 HUSB @I100@
1 WIFE @I131@
1 CHIL @I86@
1 CHIL @I130@
1 CHIL @I172@
1 SOUR @S1@
2 PAGE Volume 5, page 361
0 @F74@ FAM
1 _UID B6E9F64C29D7D711BA22AAFF03D37436CED7
1 HUSB @I87@
1 WIFE @I89@
1 MARR
2 DATE 12 Nov 1511
2 SOUR @S1@
3 PAGE Volume 8, page 63
0 @F75@ FAM
1 _UID C1E9F64C29D7D711BA22AAFF03D37436D987
1 HUSB @I87@
1 WIFE @I93@
1 MARR
2 DATE BEF 20 Feb 1530/1531
2 SOUR @S1@
3 PAGE Volume 8, page 67
0 @F76@ FAM
1 _UID BEE9F64C29D7D711BA22AAFF03D37436D657
1 HUSB @I92@
1 WIFE @I89@
1 MARR
2 DATE ABT 1501
2 SOUR @S1@
3 PAGE Volume 8, page 63; volume 14, page 443
0 @F77@ FAM
1 _UID B9E9F64C29D7D711BA22AAFF03D37436D107
1 HUSB @I90@
1 WIFE @I91@
1 CHIL @I89@
1 SOUR @S1@
2 PAGE Volume 8, page 63
0 @F78@ FAM
1 _UID C4E9F64C29D7D711BA22AAFF03D37436DCB7
1 HUSB @I94@
1 WIFE @I93@
1 SOUR @S1@
2 PAGE Volume 8, page 67
0 @F79@ FAM
1 _UID C7E9F64C29D7D711BA22AAFF03D37436DFE7
1 HUSB @I95@
1 WIFE @I96@
1 CHIL @I93@
1 SOUR @S1@
2 PAGE Volume 8, page 67
0 @F80@ FAM
1 _UID CCE9F64C29D7D711BA22AAFF03D37436E437
1 HUSB @I97@
1 CHIL @I96@
0 @F81@ FAM
1 _UID 1DEAF64C29D7D711BA22AAFF03D374363656
1 HUSB @I126@
1 WIFE @I98@
1 MARR
2 DATE AFT Jun 1482
2 SOUR @S1@
3 PAGE Volume 14, page 626
0 @F82@ FAM
1 _UID D1E9F64C29D7D711BA22AAFF03D37436E987
1 HUSB @I99@
1 WIFE @I98@
1 CHIL @I101@
1 CHIL @I102@
1 MARR
2 DATE BET 25 Nov 1487 AND 1 Jan 1488
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 449
1 EVEN
2 TYPE Marriage dissolved
2 DATE 1486
2 SOUR @S1@
3 PAGE Volume 14, page 626
0 @F83@ FAM
1 _UID DCE9F64C29D7D711BA22AAFF03D37436F437
1 HUSB @I103@
1 WIFE @I98@
1 CHIL @I271@
1 MARR
2 DATE (Possibly 13 May 1502 - Jan/Mar 1503/4)
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 450
0 @F84@ FAM
1 _UID E8E9F64C29D7D711BA22AAFF03D3743600F7
1 HUSB @I105@
1 WIFE @I107@
1 MARR
2 DATE 15 Jan 1477/1478
2 PLAC St Stephen's Chapel, Westminster
2 SOUR @S1@
3 PAGE Volume 12, part 2, page 911
0 @F85@ FAM
1 _UID EBE9F64C29D7D711BA22AAFF03D374360327
1 HUSB @I108@
1 WIFE @I109@
1 CHIL @I107@
1 SOUR @S1@
2 PAGE Volume 12, part 2, page 913
0 @F86@ FAM
1 _UID F0E9F64C29D7D711BA22AAFF03D374360877
1 HUSB @I110@
1 CHIL @I109@
0 @F87@ FAM
1 _UID F7E9F64C29D7D711BA22AAFF03D374360FE7
1 HUSB @I113@
1 WIFE @I112@
1 CHIL @I114@
1 SOUR @S1@
2 PAGE Volume 9, page 614
0 @F88@ FAM
1 _UID FCE9F64C29D7D711BA22AAFF03D374361437
1 HUSB @I115@
1 WIFE @I116@
1 CHIL @I112@
1 SOUR @S1@
2 PAGE Volume 9, page 614
0 @F89@ FAM
1 _UID 01EAF64C29D7D711BA22AAFF03D374361A96
1 HUSB @I117@
1 WIFE @I118@
1 CHIL @I116@
1 SOUR @S1@
2 PAGE Volume 9, pages 614, 615
0 @F90@ FAM
1 _UID 06EAF64C29D7D711BA22AAFF03D374361FE6
1 HUSB @I119@
1 CHIL @I118@
0 @F91@ FAM
1 _UID 0EEAF64C29D7D711BA22AAFF03D374362766
1 HUSB @I121@
1 WIFE @I123@
1 CHIL @I120@
1 CHIL @I122@
1 SOUR @S1@
2 PAGE Volume 9, page 615
0 @F92@ FAM
1 _UID 15EAF64C29D7D711BA22AAFF03D374362ED6
1 HUSB @I124@
1 CHIL @I123@
0 @F93@ FAM
1 _UID 24EAF64C29D7D711BA22AAFF03D374363DC6
1 HUSB @I129@
1 CHIL @I128@
1 CHIL @I154@
0 @F94@ FAM
1 _UID 2BEAF64C29D7D711BA22AAFF03D374364436
1 HUSB @I132@
1 CHIL @I131@
0 @F95@ FAM
1 _UID 30EAF64C29D7D711BA22AAFF03D374364986
1 HUSB @I133@
1 WIFE @I134@
1 MARR
2 DATE Oct 1466
2 PLAC Greenwich
2 SOUR @S1@
3 PAGE Volume 4, page 418
0 @F96@ FAM
1 _UID 3BEAF64C29D7D711BA22AAFF03D374365436
1 HUSB @I133@
1 WIFE @I138@
1 CHIL @I145@
1 SOUR @S1@
2 PAGE Volume 4, page 418
0 @F97@ FAM
1 _UID 33EAF64C29D7D711BA22AAFF03D374364CB6
1 HUSB @I135@
1 WIFE @I136@
1 CHIL @I134@
1 SOUR @S1@
2 PAGE Volume 4, page 418
0 @F98@ FAM
1 _UID 38EAF64C29D7D711BA22AAFF03D374365106
1 HUSB @I137@
1 CHIL @I136@
0 @F99@ FAM
1 _UID 45EAF64C29D7D711BA22AAFF03D374365ED6
1 HUSB @I141@
1 WIFE @I138@
1 SOUR @S1@
2 PAGE Volume 4, page 419
0 @F100@ FAM
1 _UID 3EEAF64C29D7D711BA22AAFF03D374365766
1 HUSB @I139@
1 WIFE @I140@
1 CHIL @I138@
1 SOUR @S1@
2 PAGE Volume 4, page 418
0 @F101@ FAM
1 _UID 26EDCE57CFD7D711BA22ACE9C2156A36AE86
1 HUSB @I151@
1 WIFE @I143@
1 CHIL @I159@
1 CHIL @I191@
1 CHIL @I192@
1 MARR
2 DATE (Early in May 1533)
2 PLAC Probably at Southwark
2 SOUR @S1@
3 PAGE Volume 4, page 421
0 @F102@ FAM
1 _UID 2BEDCE57CFD7D711BA22ACE9C2156A36B3D6
1 HUSB @I144@
1 WIFE @I143@
1 MARR
2 DATE BEF 1557
2 SOUR @S1@
3 PAGE Volume 4, page 421
0 @F103@ FAM
1 _UID AC5AFAACC0D7D711BA22A293179F6D36955C
1 HUSB @I145@
1 WIFE @I146@
1 CHIL @I151@
1 MARR
2 DATE 1509
2 SOUR @S1@
3 PAGE Volume 4, page 420
0 @F104@ FAM
1 _UID AF5AFAACC0D7D711BA22A293179F6D36988C
1 HUSB @I147@
1 WIFE @I146@
1 SOUR @S1@
2 PAGE Volume 4, page 420
0 @F105@ FAM
1 _UID B25AFAACC0D7D711BA22A293179F6D369BBC
1 HUSB @I148@
1 WIFE @I149@
1 CHIL @I146@
1 SOUR @S1@
2 PAGE Volume 4, page 420
0 @F106@ FAM
1 _UID B75AFAACC0D7D711BA22A293179F6D36A00C
1 HUSB @I150@
1 CHIL @I149@
0 @F107@ FAM
1 _UID BC5AFAACC0D7D711BA22A293179F6D36A55C
1 HUSB @I151@
1 WIFE @I152@
1 MARR
2 DATE BEF 1530
2 SOUR @S1@
3 PAGE Volume 4, page 421
1 NOTE Henry afterwards repudiated Catherine
2 SOUR @S1@
3 PAGE Volume 4, page 421
0 @F108@ FAM
1 _UID BF5AFAACC0D7D711BA22A293179F6D36A88C
1 HUSB @I153@
1 WIFE @I154@
1 CHIL @I152@
1 SOUR @S1@
2 PAGE Volume 4, page 421
0 @F110@ FAM
1 _UID 30EDCE57CFD7D711BA22ACE9C2156A36B826
1 HUSB @I157@
1 WIFE @I156@
1 CHIL @I158@
1 MARR
2 DATE (Summer 1537)
2 PLAC Suffolk Place, London
2 SOUR @S1@
3 PAGE Volume 3, page 567
0 @F111@ FAM
1 _UID 39EDCE57CFD7D711BA22ACE9C2156A36C1B6
1 HUSB @I157@
1 WIFE @I160@
1 MARR
2 DATE AFT 21 Aug 1554
2 PLAC Kirkoswald
2 SOUR @S1@
3 PAGE Volume 3, page 567; volume 14, page 226
0 @F112@ FAM
1 _UID 36EDCE57CFD7D711BA22ACE9C2156A36BE86
1 HUSB @I190@
1 WIFE @I158@
1 MARR
2 DATE 7 Feb 1555
2 PLAC Royal Chapel, Whitehall
2 SOUR @S1@
3 PAGE Volume 4, page 211
0 @F113@ FAM
1 _UID 3CEDCE57CFD7D711BA22ACE9C2156A36C4E6
1 HUSB @I161@
1 WIFE @I162@
1 CHIL @I160@
1 SOUR @S1@
2 PAGE Volume 3, pages 567, 568
0 @F114@ FAM
1 _UID 41EDCE57CFD7D711BA22ACE9C2156A36C936
1 HUSB @I163@
1 CHIL @I162@
0 @F115@ FAM
1 _UID 47EDCE57CFD7D711BA22ACE9C2156A36CF96
1 HUSB @I165@
1 WIFE @I166@
1 CHIL @I164@
1 SOUR @S1@
2 PAGE Volume 4, page 207
0 @F116@ FAM
1 _UID 4CEDCE57CFD7D711BA22ACE9C2156A36D4E6
1 HUSB @I167@
1 CHIL @I166@
0 @F117@ FAM
1 _UID 53EDCE57CFD7D711BA22ACE9C2156A36DB56
1 HUSB @I169@
1 WIFE @I170@
1 CHIL @I173@
1 MARR
2 DATE BEF 26 Feb 1481
2 SOUR @S1@
3 PAGE Volume 4, page 208
0 @F118@ FAM
1 _UID 56EDCE57CFD7D711BA22ACE9C2156A36DE86
1 HUSB @I171@
1 WIFE @I172@
1 CHIL @I170@
1 SOUR @S1@
2 PAGE Volume 4, page 208
0 @F119@ FAM
1 _UID 5DEDCE57CFD7D711BA22ACE9C2156A36E5F6
1 HUSB @I173@
1 WIFE @I174@
1 CHIL @I179@
1 MARR
2 DATE AFT 17 Dec 1505
2 SOUR @S1@
3 PAGE Volume 4, page 209; volume 14, page 251
0 @F120@ FAM
1 _UID 60EDCE57CFD7D711BA22ACE9C2156A36E826
1 HUSB @I175@
1 WIFE @I177@
1 CHIL @I174@
1 SOUR @S1@
2 PAGE Volume 4, page 209
0 @F121@ FAM
1 _UID 67EDCE57CFD7D711BA22ACE9C2156A36EF96
1 HUSB @I178@
1 CHIL @I177@
0 @F122@ FAM
1 _UID 6CEDCE57CFD7D711BA22ACE9C2156A36F4E6
1 HUSB @I179@
1 WIFE @I180@
1 CHIL @I190@
1 EVEN
2 TYPE Pardon for marrying without licence
2 DATE 21 Feb 1529/30
2 SOUR @S1@
3 PAGE Volume 4, page 210
0 @F123@ FAM
1 _UID 71EDCE57CFD7D711BA22ACE9C2156A36F936
1 HUSB @I179@
1 WIFE @I181@
1 SOUR @S1@
2 PAGE Volume 4, page 210
0 @F124@ FAM
1 _UID 7CEDCE57CFD7D711BA22ACE9C2156A3604E6
1 HUSB @I179@
1 WIFE @I185@
1 MARR
2 DATE BEF 1 Jan 1561/1562
2 SOUR @S1@
3 PAGE Volume 4, page 210
0 @F125@ FAM
1 _UID 74EDCE57CFD7D711BA22ACE9C2156A36FC66
1 HUSB @I182@
1 WIFE @I183@
1 CHIL @I181@
1 SOUR @S1@
2 PAGE Volume 4, page 210
0 @F126@ FAM
1 _UID 79EDCE57CFD7D711BA22ACE9C2156A3601B6
1 HUSB @I184@
1 CHIL @I183@
0 @F127@ FAM
1 _UID 87EDCE57CFD7D711BA22ACE9C2156A360F96
1 HUSB @I189@
1 WIFE @I185@
1 SOUR @S1@
2 PAGE Volume 4, page 211
0 @F128@ FAM
1 _UID 7FEDCE57CFD7D711BA22ACE9C2156A360716
1 HUSB @I186@
1 WIFE @I187@
1 CHIL @I185@
1 SOUR @S1@
2 PAGE Volume 4, page 210
0 @F129@ FAM
1 _UID 84EDCE57CFD7D711BA22ACE9C2156A360C66
1 HUSB @I188@
1 CHIL @I187@
0 @F130@ FAM
1 _UID A5EDCE57CFD7D711BA22ACE9C2156A362D76
1 HUSB @I198@
1 WIFE @I191@
1 SOUR @S1@
2 PAGE Volume 6, page 505
0 @F131@ FAM
1 _UID 9AEDCE57CFD7D711BA22ACE9C2156A3622C6
1 HUSB @I194@
1 WIFE @I191@
1 MARR
2 DATE ABT Dec 1560
2 PLAC Hertford House, Canon Row, Westminster
2 NOTE (privately)
2 SOUR @S1@
3 PAGE Volume 4, page 421, note c; volume 6, page 505
0 @F132@ FAM
1 _UID 97EDCE57CFD7D711BA22ACE9C2156A361F96
1 HUSB @I193@
1 WIFE @I192@
1 MARR
2 DATE Aug 1565
3 NOTE 10 or 12 August
2 SOUR @S1@
3 PAGE Volume 4, page 421, note c
0 @F133@ FAM
1 _UID A8EDCE57CFD7D711BA22ACE9C2156A3630A6
1 HUSB @I194@
1 WIFE @I199@
1 MARR
2 DATE BEF Nov 1595
2 SOUR @S1@
3 PAGE Volume 6, page 506
0 @F134@ FAM
1 _UID B8EDCE57CFD7D711BA22ACE9C2156A3640A6
1 HUSB @I194@
1 WIFE @I203@
1 SOUR @S1@
2 PAGE Volume 6, page 506
0 @F135@ FAM
1 _UID A2EDCE57CFD7D711BA22ACE9C2156A362A46
1 HUSB @I196@
1 WIFE @I197@
1 CHIL @I194@
1 SOUR @S1@
2 PAGE Volume 6, page 504
0 @F136@ FAM
1 _UID ABEDCE57CFD7D711BA22ACE9C2156A3633D6
1 HUSB @I200@
1 WIFE @I201@
1 CHIL @I199@
1 SOUR @S1@
2 PAGE Volume 6, page 506
0 @F137@ FAM
1 _UID B0EDCE57CFD7D711BA22ACE9C2156A363826
1 HUSB @I202@
1 CHIL @I201@
0 @F138@ FAM
1 _UID C7EDCE57CFD7D711BA22ACE9C2156A364F96
1 HUSB @I204@
1 WIFE @I203@
1 SOUR @S1@
2 PAGE Volume 6, page 506
0 @F139@ FAM
1 _UID C6EDCE57CFD7D711BA22ACE9C2156A364E86
1 HUSB @I208@
1 WIFE @I203@
1 SOUR @S1@
2 PAGE Volume 6, page 506
0 @F140@ FAM
1 _UID C0EDCE57CFD7D711BA22ACE9C2156A364826
1 HUSB @I205@
1 WIFE @I206@
1 CHIL @I203@
1 SOUR @S1@
2 PAGE Volume 6, page 506
0 @F141@ FAM
1 _UID C3EDCE57CFD7D711BA22ACE9C2156A364B56
1 HUSB @I207@
1 CHIL @I206@
0 @F142@ FAM
1 _UID 65E872ADF4D7D711BA224445535400002B90
1 HUSB @I210@
1 CHIL @I209@
0 @F143@ FAM
1 _UID 72E872ADF4D7D711BA224445535400003860
1 HUSB @I214@
1 CHIL @I213@
0 @F144@ FAM
1 _UID 838837EC5CD9D711BA2284A7D1D71B364B16
1 HUSB @I217@
1 CHIL @I84@
0 @F145@ FAM
1 _UID E42E9C1D51DAD711BA22444553540000EA13
1 HUSB @I88@
1 WIFE @I66@
1 CHIL @I10@
1 CHIL @I176@
1 CHIL @I168@
1 CHIL @I218@
1 CHIL @I219@
1 CHIL @I220@
1 MARR
2 DATE 8 Aug 1503
2 PLAC Abbey Church of Holyrood
2 SOUR @S2@
3 PAGE Volume 1, page 21
0 @F146@ FAM
1 _UID F52E9C1D51DAD711BA22444553540000FB23
1 HUSB @I222@
1 WIFE @I221@
1 CHIL @I223@
1 CHIL @I224@
1 MARR
2 DATE 6 Jul 1544
2 SOUR @S2@
3 PAGE Volume 1, page 22
0 @F147@ FAM
1 _UID FC2E9C1D51DAD711BA224445535400000293
1 HUSB @I224@
1 WIFE @I225@
1 CHIL @I227@
1 SOUR @S2@
2 PAGE Volume 1, page 22
0 @F148@ FAM
1 _UID FF2E9C1D51DAD711BA2244455354000005C3
1 HUSB @I226@
1 CHIL @I225@
0 @F149@ FAM
1 _UID 042F9C1D51DAD711BA224445535400000B22
1 HUSB @I228@
1 WIFE @I227@
1 SOUR @S2@
2 PAGE Volume 1, page 22
0 @F150@ FAM
1 NOTE Not married
1 _UID 072F9C1D51DAD711BA224445535400000E52
1 HUSB @I88@
1 WIFE @I229@
1 CHIL @I230@
1 CHIL @I231@
1 SOUR @S2@
2 PAGE Volume 1, page 22
0 @F151@ FAM
1 _UID 0E2F9C1D51DAD711BA2244455354000015C2
1 HUSB @I232@
1 WIFE @I231@
1 SOUR @S2@
2 PAGE Volume 1, page 22
0 @F152@ FAM
1 NOTE Not married
1 _UID 112F9C1D51DAD711BA2244455354000018F2
1 HUSB @I88@
1 WIFE @I233@
1 CHIL @I235@
1 SOUR @S2@
2 PAGE Volume 1, page 22
0 @F154@ FAM
1 _UID 192F9C1D51DAD711BA224445535400002072
1 HUSB @I235@
1 WIFE @I236@
1 SOUR @S2@
2 PAGE Volume 1, page 22
0 @F155@ FAM
1 _UID 1C2F9C1D51DAD711BA2244455354000023A2
1 HUSB @I237@
1 CHIL @I236@
0 @F156@ FAM
1 NOTE Not married
1 _UID 1F2F9C1D51DAD711BA2244455354000026D2
1 HUSB @I88@
1 WIFE @I238@
1 CHIL @I239@
1 SOUR @S2@
2 PAGE Volume 1, page 22
0 @F157@ FAM
1 _UID 242F9C1D51DAD711BA224445535400002B22
1 HUSB @I240@
1 WIFE @I239@
1 SOUR @S2@
2 PAGE Volume 1, page 22
0 @F158@ FAM
1 _UID 272F9C1D51DAD711BA224445535400002E52
1 HUSB @I241@
1 WIFE @I239@
1 SOUR @S2@
2 PAGE Volume 1, page 22
0 @F159@ FAM
1 NOTE Not married
1 _UID 2A2F9C1D51DAD711BA224445535400003182
1 HUSB @I88@
1 WIFE @I242@
1 CHIL @I244@
1 SOUR @S2@
2 PAGE Volume 1, page 22
0 @F160@ FAM
1 _UID 2D2F9C1D51DAD711BA2244455354000034B2
1 HUSB @I243@
1 CHIL @I242@
0 @F161@ FAM
1 _UID 322F9C1D51DAD711BA224445535400003902
1 HUSB @I245@
1 WIFE @I244@
1 SOUR @S2@
2 PAGE Volume 1, page 22
0 @F162@ FAM
1 NOTE Not married
1 _UID 352F9C1D51DAD711BA224445535400003C32
1 HUSB @I246@
1 WIFE @I244@
1 CHIL @I247@
1 SOUR @S2@
2 PAGE Volume 1, page 23
0 @F163@ FAM
1 _UID 3C2F9C1D51DAD711BA2244455354000043A2
1 HUSB @I218@
1 WIFE @I248@
1 MARR
2 DATE 1 Jan 1536/1537
2 PLAC N�tre Dame Cathedral, Paris
2 SOUR @S2@
3 PAGE Volume 1, page 23
0 @F164@ FAM
1 _UID 3F2F9C1D51DAD711BA2244455354000046D2
1 HUSB @I249@
1 CHIL @I248@
0 @F165@ FAM
1 _UID 422F9C1D51DAD711BA224445535400004902
1 HUSB @I218@
1 WIFE @I250@
1 CHIL @I252@
1 CHIL @I253@
1 CHIL @I254@
1 MARR
2 DATE Jun 1538
2 PLAC St Andrews
2 SOUR @S2@
3 PAGE Volume 1, page 23
0 @F166@ FAM
1 _UID 452F9C1D51DAD711BA224445535400004C32
1 HUSB @I251@
1 WIFE @I250@
1 SOUR @S2@
2 PAGE Volume 1, page 23
0 @F167@ FAM
1 _UID 4E2F9C1D51DAD711BA2244455354000055C2
1 HUSB @I255@
1 WIFE @I254@
1 MARR
2 DATE 24 Apr 1558
2 SOUR @S2@
3 PAGE Volume 1, page 26
0 @F168@ FAM
1 _UID 4F2F9C1D51DAD711BA2244455354000056D2
1 HUSB @I246@
1 WIFE @I256@
1 CHIL @I255@
1 SOUR @S2@
2 PAGE Volume 1, page 26
0 @F169@ FAM
1 _UID 522F9C1D51DAD711BA224445535400005902
1 HUSB @I223@
1 WIFE @I254@
1 CHIL @I257@
1 MARR
2 DATE 29 Jul 1565
2 SOUR @S2@
3 PAGE Volume 1, page 26
0 @F170@ FAM
1 _UID 592F9C1D51DAD711BA224445535400006072
1 HUSB @I258@
1 WIFE @I254@
1 MARR
2 DATE 15 May 1567
2 PLAC Holyrood
2 SOUR @S2@
3 PAGE Volume 1, page 26
0 @F171@ FAM
1 _UID 5C2F9C1D51DAD711BA2244455354000063A2
1 HUSB @I257@
1 WIFE @I259@
1 MARR
2 DATE 24 Nov 1589
2 PLAC Upslo, Denmark
2 SOUR @S2@
3 PAGE Volume 1, page 27
0 @F172@ FAM
1 _UID 459304CACCDAD711BA22B8E68CB2433564E1
1 HUSB @I261@
1 WIFE @I260@
1 MARR
2 DATE 4 Feb 1519/1520
2 SOUR @S3@
3 PAGE 346
0 @F173@ FAM
1 _UID 489304CACCDAD711BA22B8E68CB243356711
1 HUSB @I262@
1 WIFE @I260@
1 MARR
2 DATE BEF 1534
2 SOUR @S3@
3 PAGE 346
0 @F174@ FAM
1 NOTE Not married
1 _UID 4B9304CACCDAD711BA22B8E68CB243356A41
1 HUSB @I14@
1 WIFE @I260@
1 CHIL @I263@
1 CHIL @I264@
0 @F175@ FAM
1 _UID 569304CACCDAD711BA22B8E68CB2433575F1
1 HUSB @I267@
1 WIFE @I264@
1 MARR
2 DATE BEF May 1540
2 SOUR @S3@
3 PAGE 348
0 @F176@ FAM
1 _UID 599304CACCDAD711BA22B8E68CB243357821
1 HUSB @I263@
1 WIFE @I268@
1 SOUR @S3@
2 PAGE 349
0 @F177@ FAM
1 MARR
2 DATE 25 Jul 1554
2 PLAC Winchester Cathedral
2 SOUR @S4@
3 PAGE 541
1 _UID 5C9304CACCDAD711BA22B8E68CB243357B51
1 HUSB @I269@
1 WIFE @I266@
0 @F178@ FAM
1 HUSB @I270@
1 WIFE @I159@
1 MARR
2 DATE 21 May 1553
2 PLAC Durham House, London
2 SOUR @S5@
3 PAGE Volume 16, page 105
0 @S1@ SOUR
1 AUTH Vicary Gibbs (ed.) and others
1 TITL The Complete Peerage
1 PUBL 13 volumes (in 14 parts). London: The St Catherine Press Ltd. 1910-1959
2 CONT Volume 14 (addenda and corrigenda). Stroud: Sutton Publishing Ltd. 1998.
2 CONT Microprint edition of volumes 1-13. Gloucester: Alan Sutton Publishing Ltd. First published 1982; reprinted 2000.
0 @S2@ SOUR
1 AUTH Sir J. B. Paul (editor)
1 TITL Scots Peerage
1 PUBL 9 volumes. Edinburgh: David Douglas. 1904-1914
0 @S3@ SOUR
1 AUTH Anthony Hoskins
1 TITL Mary Boleyn's Carey children  - offspring of King Henry VIII?
1 PUBL Genealogists' Magazine (London), volume 25, number 9, pages 345-352 (March 1997)
0 @S4@ SOUR
1 AUTH J. D. Mackie
1 TITL The Earlier Tudors 1485-1558
1 PUBL Oxford: Oxford University Press. First published 1952; paperback edition 1994
0 @S5@ SOUR
1 AUTH Leslie Stephen (editor)
1 TITL Dictionary of National Biography
1 PUBL 67 volumes. London: Smith, Elder. 1885-1903
0 @N1@ NOTE Henry Stewart is said to have married firstly "the Lady Leslie", 
1 CONC who must have been divorced before March 1527/8, in which month he married Margaret Tudor
1 SOUR @S1@
2 PAGE Volume 8, pages 682, 683
0 @N2@ NOTE The name of Arthur Plantagenet's mother is unknown. She is said by some to be 
1 CONC the "Lady Elizabeth Lucy", by others the notorious Jane Shore, and by others one 
1 CONC Elizabeth Waite, he himself being at first known as Arthur Waite.
1 SOUR @S1@
2 PAGE Volume 8, page 63
0 @N3@ NOTE He died "it is said of 
1 CONC joy at the King having ordered his release on being convinced of his innocence, 
1 CONC and is said to have been bur. there."
1 SOUR @S1@
2 PAGE Volume 8, page 67
0 @N4@ NOTE The existence of such a child is claimed in pedigrees 
1 CONC at the College of Arms, and possibly confirmed by a reference in the will 
1 CONC of Lady Katherine Gordon, wife of Perkin Warbeck, to her "Cosyn Margarett Keymes"
1 SOUR @S1@
2 PAGE Volume 14, pages 626, 627
0 TRLR
`